export const sp500ValueSeries = [
    { date: '2014-01-27', value: 1781.56 },
    { date: '2014-01-28', value: 1792.5 },
    { date: '2014-01-29', value: 1774.2 },
    { date: '2014-01-30', value: 1794.19 },
    { date: '2014-01-31', value: 1782.59 },
    { date: '2014-02-03', value: 1741.89 },
    { date: '2014-02-04', value: 1755.2 },
    { date: '2014-02-05', value: 1751.64 },
    { date: '2014-02-06', value: 1773.43 },
    { date: '2014-02-07', value: 1797.02 },
    { date: '2014-02-10', value: 1799.84 },
    { date: '2014-02-11', value: 1819.75 },
    { date: '2014-02-12', value: 1819.26 },
    { date: '2014-02-13', value: 1829.83 },
    { date: '2014-02-14', value: 1838.63 },
    { date: '2014-02-18', value: 1840.76 },
    { date: '2014-02-19', value: 1828.75 },
    { date: '2014-02-20', value: 1839.78 },
    { date: '2014-02-21', value: 1836.25 },
    { date: '2014-02-24', value: 1847.61 },
    { date: '2014-02-25', value: 1845.12 },
    { date: '2014-02-26', value: 1845.16 },
    { date: '2014-02-27', value: 1854.29 },
    { date: '2014-02-28', value: 1859.45 },
    { date: '2014-03-03', value: 1845.73 },
    { date: '2014-03-04', value: 1873.91 },
    { date: '2014-03-05', value: 1873.81 },
    { date: '2014-03-06', value: 1877.03 },
    { date: '2014-03-07', value: 1878.04 },
    { date: '2014-03-10', value: 1877.17 },
    { date: '2014-03-11', value: 1867.63 },
    { date: '2014-03-12', value: 1868.2 },
    { date: '2014-03-13', value: 1846.34 },
    { date: '2014-03-14', value: 1841.13 },
    { date: '2014-03-17', value: 1858.83 },
    { date: '2014-03-18', value: 1872.25 },
    { date: '2014-03-19', value: 1860.77 },
    { date: '2014-03-20', value: 1872.01 },
    { date: '2014-03-21', value: 1866.52 },
    { date: '2014-03-24', value: 1857.44 },
    { date: '2014-03-25', value: 1865.62 },
    { date: '2014-03-26', value: 1852.56 },
    { date: '2014-03-27', value: 1849.04 },
    { date: '2014-03-28', value: 1857.62 },
    { date: '2014-03-31', value: 1872.34 },
    { date: '2014-04-01', value: 1885.52 },
    { date: '2014-04-02', value: 1890.9 },
    { date: '2014-04-03', value: 1888.77 },
    { date: '2014-04-04', value: 1865.09 },
    { date: '2014-04-07', value: 1845.04 },
    { date: '2014-04-08', value: 1851.96 },
    { date: '2014-04-09', value: 1872.18 },
    { date: '2014-04-10', value: 1833.08 },
    { date: '2014-04-11', value: 1815.69 },
    { date: '2014-04-14', value: 1830.61 },
    { date: '2014-04-15', value: 1842.98 },
    { date: '2014-04-16', value: 1862.31 },
    { date: '2014-04-17', value: 1864.85 },
    { date: '2014-04-21', value: 1871.89 },
    { date: '2014-04-22', value: 1879.55 },
    { date: '2014-04-23', value: 1875.39 },
    { date: '2014-04-24', value: 1878.61 },
    { date: '2014-04-25', value: 1863.4 },
    { date: '2014-04-28', value: 1869.43 },
    { date: '2014-04-29', value: 1878.33 },
    { date: '2014-04-30', value: 1883.95 },
    { date: '2014-05-01', value: 1883.68 },
    { date: '2014-05-02', value: 1881.14 },
    { date: '2014-05-05', value: 1884.66 },
    { date: '2014-05-06', value: 1867.72 },
    { date: '2014-05-07', value: 1878.21 },
    { date: '2014-05-08', value: 1875.63 },
    { date: '2014-05-09', value: 1878.48 },
    { date: '2014-05-12', value: 1896.65 },
    { date: '2014-05-13', value: 1897.45 },
    { date: '2014-05-14', value: 1888.53 },
    { date: '2014-05-15', value: 1870.85 },
    { date: '2014-05-16', value: 1877.86 },
    { date: '2014-05-19', value: 1885.08 },
    { date: '2014-05-20', value: 1872.83 },
    { date: '2014-05-21', value: 1888.03 },
    { date: '2014-05-22', value: 1892.49 },
    { date: '2014-05-23', value: 1900.53 },
    { date: '2014-05-27', value: 1911.91 },
    { date: '2014-05-28', value: 1909.78 },
    { date: '2014-05-29', value: 1920.03 },
    { date: '2014-05-30', value: 1923.57 },
    { date: '2014-06-02', value: 1924.97 },
    { date: '2014-06-03', value: 1924.24 },
    { date: '2014-06-04', value: 1927.88 },
    { date: '2014-06-05', value: 1940.46 },
    { date: '2014-06-06', value: 1949.44 },
    { date: '2014-06-09', value: 1951.27 },
    { date: '2014-06-10', value: 1950.79 },
    { date: '2014-06-11', value: 1943.89 },
    { date: '2014-06-12', value: 1930.11 },
    { date: '2014-06-13', value: 1936.16 },
    { date: '2014-06-16', value: 1937.78 },
    { date: '2014-06-17', value: 1941.99 },
    { date: '2014-06-18', value: 1956.98 },
    { date: '2014-06-19', value: 1959.48 },
    { date: '2014-06-20', value: 1962.87 },
    { date: '2014-06-23', value: 1962.61 },
    { date: '2014-06-24', value: 1949.98 },
    { date: '2014-06-25', value: 1959.53 },
    { date: '2014-06-26', value: 1957.22 },
    { date: '2014-06-27', value: 1960.96 },
    { date: '2014-06-30', value: 1960.23 },
    { date: '2014-07-01', value: 1973.32 },
    { date: '2014-07-02', value: 1974.62 },
    { date: '2014-07-03', value: 1985.44 },
    { date: '2014-07-07', value: 1977.65 },
    { date: '2014-07-08', value: 1963.71 },
    { date: '2014-07-09', value: 1972.83 },
    { date: '2014-07-10', value: 1964.68 },
    { date: '2014-07-11', value: 1967.57 },
    { date: '2014-07-14', value: 1977.1 },
    { date: '2014-07-15', value: 1973.28 },
    { date: '2014-07-16', value: 1981.57 },
    { date: '2014-07-17', value: 1958.12 },
    { date: '2014-07-18', value: 1978.22 },
    { date: '2014-07-21', value: 1973.63 },
    { date: '2014-07-22', value: 1983.53 },
    { date: '2014-07-23', value: 1987.01 },
    { date: '2014-07-24', value: 1987.98 },
    { date: '2014-07-25', value: 1978.34 },
    { date: '2014-07-28', value: 1978.91 },
    { date: '2014-07-29', value: 1969.95 },
    { date: '2014-07-30', value: 1970.07 },
    { date: '2014-07-31', value: 1930.67 },
    { date: '2014-08-01', value: 1925.15 },
    { date: '2014-08-04', value: 1938.99 },
    { date: '2014-08-05', value: 1920.21 },
    { date: '2014-08-06', value: 1920.24 },
    { date: '2014-08-07', value: 1909.57 },
    { date: '2014-08-08', value: 1931.59 },
    { date: '2014-08-11', value: 1936.92 },
    { date: '2014-08-12', value: 1933.75 },
    { date: '2014-08-13', value: 1946.72 },
    { date: '2014-08-14', value: 1955.18 },
    { date: '2014-08-15', value: 1955.06 },
    { date: '2014-08-18', value: 1971.74 },
    { date: '2014-08-19', value: 1981.6 },
    { date: '2014-08-20', value: 1986.51 },
    { date: '2014-08-21', value: 1992.37 },
    { date: '2014-08-22', value: 1988.4 },
    { date: '2014-08-25', value: 1997.92 },
    { date: '2014-08-26', value: 2000.02 },
    { date: '2014-08-27', value: 2000.12 },
    { date: '2014-08-28', value: 1996.74 },
    { date: '2014-08-29', value: 2003.37 },
    { date: '2014-09-02', value: 2002.28 },
    { date: '2014-09-03', value: 2000.72 },
    { date: '2014-09-04', value: 1997.65 },
    { date: '2014-09-05', value: 2007.71 },
    { date: '2014-09-08', value: 2001.54 },
    { date: '2014-09-09', value: 1988.44 },
    { date: '2014-09-10', value: 1995.69 },
    { date: '2014-09-11', value: 1997.45 },
    { date: '2014-09-12', value: 1985.54 },
    { date: '2014-09-15', value: 1984.13 },
    { date: '2014-09-16', value: 1998.98 },
    { date: '2014-09-17', value: 2001.57 },
    { date: '2014-09-18', value: 2011.36 },
    { date: '2014-09-19', value: 2010.4 },
    { date: '2014-09-22', value: 1994.29 },
    { date: '2014-09-23', value: 1982.77 },
    { date: '2014-09-24', value: 1998.3 },
    { date: '2014-09-25', value: 1965.99 },
    { date: '2014-09-26', value: 1982.85 },
    { date: '2014-09-29', value: 1977.8 },
    { date: '2014-09-30', value: 1972.29 },
    { date: '2014-10-01', value: 1946.16 },
    { date: '2014-10-02', value: 1946.17 },
    { date: '2014-10-03', value: 1967.9 },
    { date: '2014-10-06', value: 1964.82 },
    { date: '2014-10-07', value: 1935.1 },
    { date: '2014-10-08', value: 1968.89 },
    { date: '2014-10-09', value: 1928.21 },
    { date: '2014-10-10', value: 1906.13 },
    { date: '2014-10-13', value: 1874.74 },
    { date: '2014-10-14', value: 1877.7 },
    { date: '2014-10-15', value: 1862.49 },
    { date: '2014-10-16', value: 1862.76 },
    { date: '2014-10-17', value: 1886.76 },
    { date: '2014-10-20', value: 1904.01 },
    { date: '2014-10-21', value: 1941.28 },
    { date: '2014-10-22', value: 1927.11 },
    { date: '2014-10-23', value: 1950.82 },
    { date: '2014-10-24', value: 1964.58 },
    { date: '2014-10-27', value: 1961.63 },
    { date: '2014-10-28', value: 1985.05 },
    { date: '2014-10-29', value: 1982.3 },
    { date: '2014-10-30', value: 1994.65 },
    { date: '2014-10-31', value: 2018.05 },
    { date: '2014-11-03', value: 2017.81 },
    { date: '2014-11-04', value: 2012.1 },
    { date: '2014-11-05', value: 2023.57 },
    { date: '2014-11-06', value: 2031.21 },
    { date: '2014-11-07', value: 2031.92 },
    { date: '2014-11-10', value: 2038.26 },
    { date: '2014-11-11', value: 2039.68 },
    { date: '2014-11-12', value: 2038.25 },
    { date: '2014-11-13', value: 2039.33 },
    { date: '2014-11-14', value: 2039.82 },
    { date: '2014-11-17', value: 2041.32 },
    { date: '2014-11-18', value: 2051.8 },
    { date: '2014-11-19', value: 2048.72 },
    { date: '2014-11-20', value: 2052.75 },
    { date: '2014-11-21', value: 2063.5 },
    { date: '2014-11-24', value: 2069.41 },
    { date: '2014-11-25', value: 2067.03 },
    { date: '2014-11-26', value: 2072.83 },
    { date: '2014-11-28', value: 2067.56 },
    { date: '2014-12-01', value: 2053.44 },
    { date: '2014-12-02', value: 2066.55 },
    { date: '2014-12-03', value: 2074.33 },
    { date: '2014-12-04', value: 2071.92 },
    { date: '2014-12-05', value: 2075.37 },
    { date: '2014-12-08', value: 2060.31 },
    { date: '2014-12-09', value: 2059.82 },
    { date: '2014-12-10', value: 2026.14 },
    { date: '2014-12-11', value: 2035.33 },
    { date: '2014-12-12', value: 2002.33 },
    { date: '2014-12-15', value: 1989.63 },
    { date: '2014-12-16', value: 1972.74 },
    { date: '2014-12-17', value: 2012.89 },
    { date: '2014-12-18', value: 2061.23 },
    { date: '2014-12-19', value: 2070.65 },
    { date: '2014-12-22', value: 2078.54 },
    { date: '2014-12-23', value: 2082.17 },
    { date: '2014-12-24', value: 2081.88 },
    { date: '2014-12-26', value: 2088.77 },
    { date: '2014-12-29', value: 2090.57 },
    { date: '2014-12-30', value: 2080.35 },
    { date: '2014-12-31', value: 2058.9 },
    { date: '2015-01-02', value: 2058.2 },
    { date: '2015-01-05', value: 2020.58 },
    { date: '2015-01-06', value: 2002.61 },
    { date: '2015-01-07', value: 2025.9 },
    { date: '2015-01-08', value: 2062.14 },
    { date: '2015-01-09', value: 2044.81 },
    { date: '2015-01-12', value: 2028.26 },
    { date: '2015-01-13', value: 2023.03 },
    { date: '2015-01-14', value: 2011.27 },
    { date: '2015-01-15', value: 1992.67 },
    { date: '2015-01-16', value: 2019.42 },
    { date: '2015-01-20', value: 2022.55 },
    { date: '2015-01-21', value: 2032.12 },
    { date: '2015-01-22', value: 2063.15 },
    { date: '2015-01-23', value: 2051.82 },
    { date: '2015-01-26', value: 2057.09 },
    { date: '2015-01-27', value: 2029.55 },
    { date: '2015-01-28', value: 2002.16 },
    { date: '2015-01-29', value: 2021.25 },
    { date: '2015-01-30', value: 1994.99 },
    { date: '2015-02-02', value: 2020.85 },
    { date: '2015-02-03', value: 2050.03 },
    { date: '2015-02-04', value: 2041.51 },
    { date: '2015-02-05', value: 2062.52 },
    { date: '2015-02-06', value: 2055.47 },
    { date: '2015-02-09', value: 2046.74 },
    { date: '2015-02-10', value: 2068.59 },
    { date: '2015-02-11', value: 2068.53 },
    { date: '2015-02-12', value: 2088.48 },
    { date: '2015-02-13', value: 2096.99 },
    { date: '2015-02-17', value: 2100.34 },
    { date: '2015-02-18', value: 2099.68 },
    { date: '2015-02-19', value: 2097.45 },
    { date: '2015-02-20', value: 2110.3 },
    { date: '2015-02-23', value: 2109.66 },
    { date: '2015-02-24', value: 2115.48 },
    { date: '2015-02-25', value: 2113.86 },
    { date: '2015-02-26', value: 2110.74 },
    { date: '2015-02-27', value: 2104.5 },
    { date: '2015-03-02', value: 2117.39 },
    { date: '2015-03-03', value: 2107.78 },
    { date: '2015-03-04', value: 2098.53 },
    { date: '2015-03-05', value: 2101.04 },
    { date: '2015-03-06', value: 2071.26 },
    { date: '2015-03-09', value: 2079.43 },
    { date: '2015-03-10', value: 2044.16 },
    { date: '2015-03-11', value: 2040.24 },
    { date: '2015-03-12', value: 2065.95 },
    { date: '2015-03-13', value: 2053.4 },
    { date: '2015-03-16', value: 2081.19 },
    { date: '2015-03-17', value: 2074.28 },
    { date: '2015-03-18', value: 2099.5 },
    { date: '2015-03-19', value: 2089.27 },
    { date: '2015-03-20', value: 2108.1 },
    { date: '2015-03-23', value: 2104.42 },
    { date: '2015-03-24', value: 2091.5 },
    { date: '2015-03-25', value: 2061.05 },
    { date: '2015-03-26', value: 2056.15 },
    { date: '2015-03-27', value: 2061.02 },
    { date: '2015-03-30', value: 2086.24 },
    { date: '2015-03-31', value: 2067.89 },
    { date: '2015-04-01', value: 2059.69 },
    { date: '2015-04-02', value: 2066.96 },
    { date: '2015-04-06', value: 2080.62 },
    { date: '2015-04-07', value: 2076.33 },
    { date: '2015-04-08', value: 2081.9 },
    { date: '2015-04-09', value: 2091.18 },
    { date: '2015-04-10', value: 2102.06 },
    { date: '2015-04-13', value: 2092.43 },
    { date: '2015-04-14', value: 2095.84 },
    { date: '2015-04-15', value: 2106.63 },
    { date: '2015-04-16', value: 2104.99 },
    { date: '2015-04-17', value: 2081.18 },
    { date: '2015-04-20', value: 2100.4 },
    { date: '2015-04-21', value: 2097.29 },
    { date: '2015-04-22', value: 2107.96 },
    { date: '2015-04-23', value: 2112.93 },
    { date: '2015-04-24', value: 2117.69 },
    { date: '2015-04-27', value: 2108.92 },
    { date: '2015-04-28', value: 2114.76 },
    { date: '2015-04-29', value: 2106.85 },
    { date: '2015-04-30', value: 2085.51 },
    { date: '2015-05-01', value: 2108.29 },
    { date: '2015-05-04', value: 2114.49 },
    { date: '2015-05-05', value: 2089.46 },
    { date: '2015-05-06', value: 2080.15 },
    { date: '2015-05-07', value: 2088.0 },
    { date: '2015-05-08', value: 2116.1 },
    { date: '2015-05-11', value: 2105.33 },
    { date: '2015-05-12', value: 2099.12 },
    { date: '2015-05-13', value: 2098.48 },
    { date: '2015-05-14', value: 2121.1 },
    { date: '2015-05-15', value: 2122.73 },
    { date: '2015-05-18', value: 2129.2 },
    { date: '2015-05-19', value: 2127.83 },
    { date: '2015-05-20', value: 2125.85 },
    { date: '2015-05-21', value: 2130.82 },
    { date: '2015-05-22', value: 2126.06 },
    { date: '2015-05-26', value: 2104.2 },
    { date: '2015-05-27', value: 2123.48 },
    { date: '2015-05-28', value: 2120.79 },
    { date: '2015-05-29', value: 2107.39 },
    { date: '2015-06-01', value: 2111.73 },
    { date: '2015-06-02', value: 2109.6 },
    { date: '2015-06-03', value: 2114.07 },
    { date: '2015-06-04', value: 2095.84 },
    { date: '2015-06-05', value: 2092.83 },
    { date: '2015-06-08', value: 2079.28 },
    { date: '2015-06-09', value: 2080.15 },
    { date: '2015-06-10', value: 2105.2 },
    { date: '2015-06-11', value: 2108.86 },
    { date: '2015-06-12', value: 2094.11 },
    { date: '2015-06-15', value: 2084.43 },
    { date: '2015-06-16', value: 2096.29 },
    { date: '2015-06-17', value: 2100.44 },
    { date: '2015-06-18', value: 2121.24 },
    { date: '2015-06-19', value: 2109.99 },
    { date: '2015-06-22', value: 2122.85 },
    { date: '2015-06-23', value: 2124.2 },
    { date: '2015-06-24', value: 2108.58 },
    { date: '2015-06-25', value: 2102.31 },
    { date: '2015-06-26', value: 2101.49 },
    { date: '2015-06-29', value: 2057.64 },
    { date: '2015-06-30', value: 2063.11 },
    { date: '2015-07-01', value: 2077.42 },
    { date: '2015-07-02', value: 2076.78 },
    { date: '2015-07-06', value: 2068.76 },
    { date: '2015-07-07', value: 2081.34 },
    { date: '2015-07-08', value: 2046.68 },
    { date: '2015-07-09', value: 2051.31 },
    { date: '2015-07-10', value: 2076.62 },
    { date: '2015-07-13', value: 2099.6 },
    { date: '2015-07-14', value: 2108.95 },
    { date: '2015-07-15', value: 2107.4 },
    { date: '2015-07-16', value: 2124.29 },
    { date: '2015-07-17', value: 2126.64 },
    { date: '2015-07-20', value: 2128.28 },
    { date: '2015-07-21', value: 2119.21 },
    { date: '2015-07-22', value: 2114.15 },
    { date: '2015-07-23', value: 2102.15 },
    { date: '2015-07-24', value: 2079.65 },
    { date: '2015-07-27', value: 2067.64 },
    { date: '2015-07-28', value: 2093.25 },
    { date: '2015-07-29', value: 2108.57 },
    { date: '2015-07-30', value: 2108.63 },
    { date: '2015-07-31', value: 2103.84 },
    { date: '2015-08-03', value: 2098.04 },
    { date: '2015-08-04', value: 2093.32 },
    { date: '2015-08-05', value: 2099.84 },
    { date: '2015-08-06', value: 2083.56 },
    { date: '2015-08-07', value: 2077.57 },
    { date: '2015-08-10', value: 2104.18 },
    { date: '2015-08-11', value: 2084.07 },
    { date: '2015-08-12', value: 2086.05 },
    { date: '2015-08-13', value: 2083.39 },
    { date: '2015-08-14', value: 2091.54 },
    { date: '2015-08-17', value: 2102.44 },
    { date: '2015-08-18', value: 2096.92 },
    { date: '2015-08-19', value: 2079.61 },
    { date: '2015-08-20', value: 2035.73 },
    { date: '2015-08-21', value: 1970.89 },
    { date: '2015-08-24', value: 1893.21 },
    { date: '2015-08-25', value: 1867.61 },
    { date: '2015-08-26', value: 1940.51 },
    { date: '2015-08-27', value: 1987.66 },
    { date: '2015-08-28', value: 1988.87 },
    { date: '2015-08-31', value: 1972.18 },
    { date: '2015-09-01', value: 1913.85 },
    { date: '2015-09-02', value: 1948.86 },
    { date: '2015-09-03', value: 1951.13 },
    { date: '2015-09-04', value: 1921.22 },
    { date: '2015-09-08', value: 1969.41 },
    { date: '2015-09-09', value: 1942.04 },
    { date: '2015-09-10', value: 1952.29 },
    { date: '2015-09-11', value: 1961.05 },
    { date: '2015-09-14', value: 1953.03 },
    { date: '2015-09-15', value: 1978.09 },
    { date: '2015-09-16', value: 1995.31 },
    { date: '2015-09-17', value: 1990.2 },
    { date: '2015-09-18', value: 1958.03 },
    { date: '2015-09-21', value: 1966.97 },
    { date: '2015-09-22', value: 1942.74 },
    { date: '2015-09-23', value: 1938.76 },
    { date: '2015-09-24', value: 1932.24 },
    { date: '2015-09-25', value: 1931.34 },
    { date: '2015-09-28', value: 1881.77 },
    { date: '2015-09-29', value: 1884.09 },
    { date: '2015-09-30', value: 1920.03 },
    { date: '2015-10-01', value: 1923.82 },
    { date: '2015-10-02', value: 1951.36 },
    { date: '2015-10-05', value: 1987.05 },
    { date: '2015-10-06', value: 1979.92 },
    { date: '2015-10-07', value: 1995.83 },
    { date: '2015-10-08', value: 2013.43 },
    { date: '2015-10-09', value: 2014.89 },
    { date: '2015-10-12', value: 2017.46 },
    { date: '2015-10-13', value: 2003.69 },
    { date: '2015-10-14', value: 1994.24 },
    { date: '2015-10-15', value: 2023.86 },
    { date: '2015-10-16', value: 2033.11 },
    { date: '2015-10-19', value: 2033.66 },
    { date: '2015-10-20', value: 2030.77 },
    { date: '2015-10-21', value: 2018.94 },
    { date: '2015-10-22', value: 2052.51 },
    { date: '2015-10-23', value: 2075.15 },
    { date: '2015-10-26', value: 2071.18 },
    { date: '2015-10-27', value: 2065.89 },
    { date: '2015-10-28', value: 2090.35 },
    { date: '2015-10-29', value: 2089.41 },
    { date: '2015-10-30', value: 2079.36 },
    { date: '2015-11-02', value: 2104.05 },
    { date: '2015-11-03', value: 2109.79 },
    { date: '2015-11-04', value: 2102.31 },
    { date: '2015-11-05', value: 2099.93 },
    { date: '2015-11-06', value: 2099.2 },
    { date: '2015-11-09', value: 2078.58 },
    { date: '2015-11-10', value: 2081.72 },
    { date: '2015-11-11', value: 2075.0 },
    { date: '2015-11-12', value: 2045.97 },
    { date: '2015-11-13', value: 2023.04 },
    { date: '2015-11-16', value: 2053.19 },
    { date: '2015-11-17', value: 2050.44 },
    { date: '2015-11-18', value: 2083.58 },
    { date: '2015-11-19', value: 2081.24 },
    { date: '2015-11-20', value: 2089.17 },
    { date: '2015-11-23', value: 2086.59 },
    { date: '2015-11-24', value: 2089.14 },
    { date: '2015-11-25', value: 2088.87 },
    { date: '2015-11-27', value: 2090.11 },
    { date: '2015-11-30', value: 2080.41 },
    { date: '2015-12-01', value: 2102.63 },
    { date: '2015-12-02', value: 2079.51 },
    { date: '2015-12-03', value: 2049.62 },
    { date: '2015-12-04', value: 2091.69 },
    { date: '2015-12-07', value: 2077.07 },
    { date: '2015-12-08', value: 2063.59 },
    { date: '2015-12-09', value: 2047.62 },
    { date: '2015-12-10', value: 2052.23 },
    { date: '2015-12-11', value: 2012.37 },
    { date: '2015-12-14', value: 2021.94 },
    { date: '2015-12-15', value: 2043.41 },
    { date: '2015-12-16', value: 2073.07 },
    { date: '2015-12-17', value: 2041.89 },
    { date: '2015-12-18', value: 2005.55 },
    { date: '2015-12-21', value: 2021.15 },
    { date: '2015-12-22', value: 2038.97 },
    { date: '2015-12-23', value: 2064.29 },
    { date: '2015-12-24', value: 2060.99 },
    { date: '2015-12-28', value: 2056.5 },
    { date: '2015-12-29', value: 2078.36 },
    { date: '2015-12-30', value: 2063.36 },
    { date: '2015-12-31', value: 2043.94 },
    { date: '2016-01-04', value: 2012.66 },
    { date: '2016-01-05', value: 2016.71 },
    { date: '2016-01-06', value: 1990.26 },
    { date: '2016-01-07', value: 1943.09 },
    { date: '2016-01-08', value: 1922.03 },
    { date: '2016-01-11', value: 1923.67 },
    { date: '2016-01-12', value: 1938.68 },
    { date: '2016-01-13', value: 1890.28 },
    { date: '2016-01-14', value: 1921.84 },
    { date: '2016-01-15', value: 1880.33 },
    { date: '2016-01-19', value: 1881.33 },
    { date: '2016-01-20', value: 1859.33 },
    { date: '2016-01-21', value: 1868.99 },
    { date: '2016-01-22', value: 1906.9 },
    { date: '2016-01-25', value: 1877.08 },
    { date: '2016-01-26', value: 1903.63 },
    { date: '2016-01-27', value: 1882.95 },
    { date: '2016-01-28', value: 1893.36 },
    { date: '2016-01-29', value: 1940.24 },
    { date: '2016-02-01', value: 1939.38 },
    { date: '2016-02-02', value: 1903.03 },
    { date: '2016-02-03', value: 1912.53 },
    { date: '2016-02-04', value: 1915.45 },
    { date: '2016-02-05', value: 1880.05 },
    { date: '2016-02-08', value: 1853.44 },
    { date: '2016-02-09', value: 1852.21 },
    { date: '2016-02-10', value: 1851.86 },
    { date: '2016-02-11', value: 1829.08 },
    { date: '2016-02-12', value: 1864.78 },
    { date: '2016-02-16', value: 1895.58 },
    { date: '2016-02-17', value: 1926.82 },
    { date: '2016-02-18', value: 1917.83 },
    { date: '2016-02-19', value: 1917.78 },
    { date: '2016-02-22', value: 1945.5 },
    { date: '2016-02-23', value: 1921.27 },
    { date: '2016-02-24', value: 1929.8 },
    { date: '2016-02-25', value: 1951.7 },
    { date: '2016-02-26', value: 1948.05 },
    { date: '2016-02-29', value: 1932.23 },
    { date: '2016-03-01', value: 1978.35 },
    { date: '2016-03-02', value: 1986.45 },
    { date: '2016-03-03', value: 1993.4 },
    { date: '2016-03-04', value: 1999.99 },
    { date: '2016-03-07', value: 2001.76 },
    { date: '2016-03-08', value: 1979.26 },
    { date: '2016-03-09', value: 1989.26 },
    { date: '2016-03-10', value: 1989.57 },
    { date: '2016-03-11', value: 2022.19 },
    { date: '2016-03-14', value: 2019.64 },
    { date: '2016-03-15', value: 2015.93 },
    { date: '2016-03-16', value: 2027.22 },
    { date: '2016-03-17', value: 2040.59 },
    { date: '2016-03-18', value: 2049.58 },
    { date: '2016-03-21', value: 2051.6 },
    { date: '2016-03-22', value: 2049.8 },
    { date: '2016-03-23', value: 2036.71 },
    { date: '2016-03-24', value: 2035.94 },
    { date: '2016-03-28', value: 2037.05 },
    { date: '2016-03-29', value: 2055.01 },
    { date: '2016-03-30', value: 2063.95 },
    { date: '2016-03-31', value: 2059.74 },
    { date: '2016-04-01', value: 2072.78 },
    { date: '2016-04-04', value: 2066.13 },
    { date: '2016-04-05', value: 2045.17 },
    { date: '2016-04-06', value: 2066.66 },
    { date: '2016-04-07', value: 2041.91 },
    { date: '2016-04-08', value: 2047.6 },
    { date: '2016-04-11', value: 2041.99 },
    { date: '2016-04-12', value: 2061.72 },
    { date: '2016-04-13', value: 2082.42 },
    { date: '2016-04-14', value: 2082.78 },
    { date: '2016-04-15', value: 2080.73 },
    { date: '2016-04-18', value: 2094.34 },
    { date: '2016-04-19', value: 2100.8 },
    { date: '2016-04-20', value: 2102.4 },
    { date: '2016-04-21', value: 2091.48 },
    { date: '2016-04-22', value: 2091.58 },
    { date: '2016-04-25', value: 2087.79 },
    { date: '2016-04-26', value: 2091.7 },
    { date: '2016-04-27', value: 2095.15 },
    { date: '2016-04-28', value: 2075.81 },
    { date: '2016-04-29', value: 2065.3 },
    { date: '2016-05-02', value: 2081.43 },
    { date: '2016-05-03', value: 2063.37 },
    { date: '2016-05-04', value: 2051.12 },
    { date: '2016-05-05', value: 2050.63 },
    { date: '2016-05-06', value: 2057.14 },
    { date: '2016-05-09', value: 2058.69 },
    { date: '2016-05-10', value: 2084.39 },
    { date: '2016-05-11', value: 2064.46 },
    { date: '2016-05-12', value: 2064.11 },
    { date: '2016-05-13', value: 2046.61 },
    { date: '2016-05-16', value: 2066.66 },
    { date: '2016-05-17', value: 2047.21 },
    { date: '2016-05-18', value: 2047.63 },
    { date: '2016-05-19', value: 2040.04 },
    { date: '2016-05-20', value: 2052.32 },
    { date: '2016-05-23', value: 2048.04 },
    { date: '2016-05-24', value: 2076.06 },
    { date: '2016-05-25', value: 2090.54 },
    { date: '2016-05-26', value: 2090.1 },
    { date: '2016-05-27', value: 2099.06 },
    { date: '2016-05-31', value: 2096.96 },
    { date: '2016-06-01', value: 2099.33 },
    { date: '2016-06-02', value: 2105.26 },
    { date: '2016-06-03', value: 2099.13 },
    { date: '2016-06-06', value: 2109.41 },
    { date: '2016-06-07', value: 2112.13 },
    { date: '2016-06-08', value: 2119.12 },
    { date: '2016-06-09', value: 2115.48 },
    { date: '2016-06-10', value: 2096.07 },
    { date: '2016-06-13', value: 2079.06 },
    { date: '2016-06-14', value: 2075.32 },
    { date: '2016-06-15', value: 2071.5 },
    { date: '2016-06-16', value: 2077.99 },
    { date: '2016-06-17', value: 2071.22 },
    { date: '2016-06-20', value: 2083.25 },
    { date: '2016-06-21', value: 2088.9 },
    { date: '2016-06-22', value: 2085.45 },
    { date: '2016-06-23', value: 2113.32 },
    { date: '2016-06-24', value: 2037.41 },
    { date: '2016-06-27', value: 2000.54 },
    { date: '2016-06-28', value: 2036.09 },
    { date: '2016-06-29', value: 2070.77 },
    { date: '2016-06-30', value: 2098.86 },
    { date: '2016-07-01', value: 2102.95 },
    { date: '2016-07-05', value: 2088.55 },
    { date: '2016-07-06', value: 2099.73 },
    { date: '2016-07-07', value: 2097.9 },
    { date: '2016-07-08', value: 2129.9 },
    { date: '2016-07-11', value: 2137.16 },
    { date: '2016-07-12', value: 2152.14 },
    { date: '2016-07-13', value: 2152.43 },
    { date: '2016-07-14', value: 2163.75 },
    { date: '2016-07-15', value: 2161.74 },
    { date: '2016-07-18', value: 2166.89 },
    { date: '2016-07-19', value: 2163.78 },
    { date: '2016-07-20', value: 2173.02 },
    { date: '2016-07-21', value: 2165.17 },
    { date: '2016-07-22', value: 2175.03 },
    { date: '2016-07-25', value: 2168.48 },
    { date: '2016-07-26', value: 2169.18 },
    { date: '2016-07-27', value: 2166.58 },
    { date: '2016-07-28', value: 2170.06 },
    { date: '2016-07-29', value: 2173.6 },
    { date: '2016-08-01', value: 2170.84 },
    { date: '2016-08-02', value: 2157.03 },
    { date: '2016-08-03', value: 2163.79 },
    { date: '2016-08-04', value: 2164.25 },
    { date: '2016-08-05', value: 2182.87 },
    { date: '2016-08-08', value: 2180.89 },
    { date: '2016-08-09', value: 2181.74 },
    { date: '2016-08-10', value: 2175.49 },
    { date: '2016-08-11', value: 2185.79 },
    { date: '2016-08-12', value: 2184.05 },
    { date: '2016-08-15', value: 2190.15 },
    { date: '2016-08-16', value: 2178.15 },
    { date: '2016-08-17', value: 2182.22 },
    { date: '2016-08-18', value: 2187.02 },
    { date: '2016-08-19', value: 2183.87 },
    { date: '2016-08-22', value: 2182.64 },
    { date: '2016-08-23', value: 2186.9 },
    { date: '2016-08-24', value: 2175.44 },
    { date: '2016-08-25', value: 2172.47 },
    { date: '2016-08-26', value: 2169.04 },
    { date: '2016-08-29', value: 2180.38 },
    { date: '2016-08-30', value: 2176.12 },
    { date: '2016-08-31', value: 2170.95 },
    { date: '2016-09-01', value: 2170.86 },
    { date: '2016-09-02', value: 2179.98 },
    { date: '2016-09-06', value: 2186.48 },
    { date: '2016-09-07', value: 2186.16 },
    { date: '2016-09-08', value: 2181.3 },
    { date: '2016-09-09', value: 2127.81 },
    { date: '2016-09-12', value: 2159.04 },
    { date: '2016-09-13', value: 2127.02 },
    { date: '2016-09-14', value: 2125.77 },
    { date: '2016-09-15', value: 2147.26 },
    { date: '2016-09-16', value: 2139.16 },
    { date: '2016-09-19', value: 2139.12 },
    { date: '2016-09-20', value: 2139.76 },
    { date: '2016-09-21', value: 2163.12 },
    { date: '2016-09-22', value: 2177.18 },
    { date: '2016-09-23', value: 2164.69 },
    { date: '2016-09-26', value: 2146.1 },
    { date: '2016-09-27', value: 2159.93 },
    { date: '2016-09-28', value: 2171.37 },
    { date: '2016-09-29', value: 2151.13 },
    { date: '2016-09-30', value: 2168.27 },
    { date: '2016-10-03', value: 2161.2 },
    { date: '2016-10-04', value: 2150.49 },
    { date: '2016-10-05', value: 2159.73 },
    { date: '2016-10-06', value: 2160.77 },
    { date: '2016-10-07', value: 2153.74 },
    { date: '2016-10-10', value: 2163.66 },
    { date: '2016-10-11', value: 2136.73 },
    { date: '2016-10-12', value: 2139.18 },
    { date: '2016-10-13', value: 2132.55 },
    { date: '2016-10-14', value: 2132.98 },
    { date: '2016-10-17', value: 2126.5 },
    { date: '2016-10-18', value: 2139.6 },
    { date: '2016-10-19', value: 2144.29 },
    { date: '2016-10-20', value: 2141.34 },
    { date: '2016-10-21', value: 2141.16 },
    { date: '2016-10-24', value: 2151.33 },
    { date: '2016-10-25', value: 2143.16 },
    { date: '2016-10-26', value: 2139.43 },
    { date: '2016-10-27', value: 2133.04 },
    { date: '2016-10-28', value: 2126.41 },
    { date: '2016-10-31', value: 2126.15 },
    { date: '2016-11-01', value: 2111.72 },
    { date: '2016-11-02', value: 2097.94 },
    { date: '2016-11-03', value: 2088.66 },
    { date: '2016-11-04', value: 2085.18 },
    { date: '2016-11-07', value: 2131.52 },
    { date: '2016-11-08', value: 2139.56 },
    { date: '2016-11-09', value: 2163.26 },
    { date: '2016-11-10', value: 2167.48 },
    { date: '2016-11-11', value: 2164.45 },
    { date: '2016-11-14', value: 2164.2 },
    { date: '2016-11-15', value: 2180.39 },
    { date: '2016-11-16', value: 2176.94 },
    { date: '2016-11-17', value: 2187.12 },
    { date: '2016-11-18', value: 2181.9 },
    { date: '2016-11-21', value: 2198.18 },
    { date: '2016-11-22', value: 2202.94 },
    { date: '2016-11-23', value: 2204.72 },
    { date: '2016-11-25', value: 2213.35 },
    { date: '2016-11-28', value: 2201.72 },
    { date: '2016-11-29', value: 2204.66 },
    { date: '2016-11-30', value: 2198.81 },
    { date: '2016-12-01', value: 2191.08 },
    { date: '2016-12-02', value: 2191.95 },
    { date: '2016-12-05', value: 2204.71 },
    { date: '2016-12-06', value: 2212.23 },
    { date: '2016-12-07', value: 2241.35 },
    { date: '2016-12-08', value: 2246.19 },
    { date: '2016-12-09', value: 2259.53 },
    { date: '2016-12-12', value: 2256.96 },
    { date: '2016-12-13', value: 2271.72 },
    { date: '2016-12-14', value: 2253.28 },
    { date: '2016-12-15', value: 2262.03 },
    { date: '2016-12-16', value: 2258.07 },
    { date: '2016-12-19', value: 2262.53 },
    { date: '2016-12-20', value: 2270.76 },
    { date: '2016-12-21', value: 2265.18 },
    { date: '2016-12-22', value: 2260.96 },
    { date: '2016-12-23', value: 2263.79 },
    { date: '2016-12-27', value: 2268.88 },
    { date: '2016-12-28', value: 2249.92 },
    { date: '2016-12-29', value: 2249.26 },
    { date: '2016-12-30', value: 2238.83 },
    { date: '2017-01-03', value: 2257.83 },
    { date: '2017-01-04', value: 2270.75 },
    { date: '2017-01-05', value: 2269.0 },
    { date: '2017-01-06', value: 2276.98 },
    { date: '2017-01-09', value: 2268.9 },
    { date: '2017-01-10', value: 2268.9 },
    { date: '2017-01-11', value: 2275.32 },
    { date: '2017-01-12', value: 2270.44 },
    { date: '2017-01-13', value: 2274.64 },
    { date: '2017-01-17', value: 2267.89 },
    { date: '2017-01-18', value: 2271.89 },
    { date: '2017-01-19', value: 2263.69 },
    { date: '2017-01-20', value: 2271.31 },
    { date: '2017-01-23', value: 2265.2 },
    { date: '2017-01-24', value: 2280.07 },
    { date: '2017-01-25', value: 2298.37 },
    { date: '2017-01-26', value: 2296.68 },
    { date: '2017-01-27', value: 2294.69 },
    { date: '2017-01-30', value: 2280.9 },
    { date: '2017-01-31', value: 2278.87 },
    { date: '2017-02-01', value: 2279.55 },
    { date: '2017-02-02', value: 2280.85 },
    { date: '2017-02-03', value: 2297.42 },
    { date: '2017-02-06', value: 2292.56 },
    { date: '2017-02-07', value: 2293.08 },
    { date: '2017-02-08', value: 2294.67 },
    { date: '2017-02-09', value: 2307.87 },
    { date: '2017-02-10', value: 2316.1 },
    { date: '2017-02-13', value: 2328.25 },
    { date: '2017-02-14', value: 2337.58 },
    { date: '2017-02-15', value: 2349.25 },
    { date: '2017-02-16', value: 2347.22 },
    { date: '2017-02-17', value: 2351.16 },
    { date: '2017-02-21', value: 2365.38 },
    { date: '2017-02-22', value: 2362.82 },
    { date: '2017-02-23', value: 2363.81 },
    { date: '2017-02-24', value: 2367.34 },
    { date: '2017-02-27', value: 2369.75 },
    { date: '2017-02-28', value: 2363.64 },
    { date: '2017-03-01', value: 2395.96 },
    { date: '2017-03-02', value: 2381.92 },
    { date: '2017-03-03', value: 2383.12 },
    { date: '2017-03-06', value: 2375.31 },
    { date: '2017-03-07', value: 2368.39 },
    { date: '2017-03-08', value: 2362.98 },
    { date: '2017-03-09', value: 2364.87 },
    { date: '2017-03-10', value: 2372.6 },
    { date: '2017-03-13', value: 2373.47 },
    { date: '2017-03-14', value: 2365.45 },
    { date: '2017-03-15', value: 2385.26 },
    { date: '2017-03-16', value: 2381.38 },
    { date: '2017-03-17', value: 2378.25 },
    { date: '2017-03-20', value: 2373.47 },
    { date: '2017-03-21', value: 2344.02 },
    { date: '2017-03-22', value: 2348.45 },
    { date: '2017-03-23', value: 2345.96 },
    { date: '2017-03-24', value: 2343.98 },
    { date: '2017-03-27', value: 2341.59 },
    { date: '2017-03-28', value: 2358.57 },
    { date: '2017-03-29', value: 2361.13 },
    { date: '2017-03-30', value: 2368.06 },
    { date: '2017-03-31', value: 2362.72 },
    { date: '2017-04-03', value: 2358.84 },
    { date: '2017-04-04', value: 2360.16 },
    { date: '2017-04-05', value: 2352.95 },
    { date: '2017-04-06', value: 2357.49 },
    { date: '2017-04-07', value: 2355.54 },
    { date: '2017-04-10', value: 2357.16 },
    { date: '2017-04-11', value: 2353.78 },
    { date: '2017-04-12', value: 2344.93 },
    { date: '2017-04-13', value: 2328.95 },
    { date: '2017-04-17', value: 2349.01 },
    { date: '2017-04-18', value: 2342.19 },
    { date: '2017-04-19', value: 2338.17 },
    { date: '2017-04-20', value: 2355.84 },
    { date: '2017-04-21', value: 2348.69 },
    { date: '2017-04-24', value: 2374.15 },
    { date: '2017-04-25', value: 2388.61 },
    { date: '2017-04-26', value: 2387.45 },
    { date: '2017-04-27', value: 2388.77 },
    { date: '2017-04-28', value: 2384.2 },
    { date: '2017-05-01', value: 2388.33 },
    { date: '2017-05-02', value: 2391.17 },
    { date: '2017-05-03', value: 2388.13 },
    { date: '2017-05-04', value: 2389.52 },
    { date: '2017-05-05', value: 2399.29 },
    { date: '2017-05-08', value: 2399.38 },
    { date: '2017-05-09', value: 2396.92 },
    { date: '2017-05-10', value: 2399.63 },
    { date: '2017-05-11', value: 2394.44 },
    { date: '2017-05-12', value: 2390.9 },
    { date: '2017-05-15', value: 2402.32 },
    { date: '2017-05-16', value: 2400.67 },
    { date: '2017-05-17', value: 2357.03 },
    { date: '2017-05-18', value: 2365.72 },
    { date: '2017-05-19', value: 2381.73 },
    { date: '2017-05-22', value: 2394.02 },
    { date: '2017-05-23', value: 2398.42 },
    { date: '2017-05-24', value: 2404.39 },
    { date: '2017-05-25', value: 2415.07 },
    { date: '2017-05-26', value: 2415.82 },
    { date: '2017-05-30', value: 2412.91 },
    { date: '2017-05-31', value: 2411.8 },
    { date: '2017-06-01', value: 2430.06 },
    { date: '2017-06-02', value: 2439.07 },
    { date: '2017-06-05', value: 2436.1 },
    { date: '2017-06-06', value: 2429.33 },
    { date: '2017-06-07', value: 2433.14 },
    { date: '2017-06-08', value: 2433.79 },
    { date: '2017-06-09', value: 2431.77 },
    { date: '2017-06-12', value: 2429.39 },
    { date: '2017-06-13', value: 2440.35 },
    { date: '2017-06-14', value: 2437.92 },
    { date: '2017-06-15', value: 2432.46 },
    { date: '2017-06-16', value: 2433.15 },
    { date: '2017-06-19', value: 2453.46 },
    { date: '2017-06-20', value: 2437.03 },
    { date: '2017-06-21', value: 2435.61 },
    { date: '2017-06-22', value: 2434.5 },
    { date: '2017-06-23', value: 2438.3 },
    { date: '2017-06-26', value: 2439.07 },
    { date: '2017-06-27', value: 2419.38 },
    { date: '2017-06-28', value: 2440.69 },
    { date: '2017-06-29', value: 2419.7 },
    { date: '2017-06-30', value: 2423.41 },
    { date: '2017-07-03', value: 2429.01 },
    { date: '2017-07-05', value: 2432.54 },
    { date: '2017-07-06', value: 2409.75 },
    { date: '2017-07-07', value: 2425.18 },
    { date: '2017-07-10', value: 2427.43 },
    { date: '2017-07-11', value: 2425.53 },
    { date: '2017-07-12', value: 2443.25 },
    { date: '2017-07-13', value: 2447.83 },
    { date: '2017-07-14', value: 2459.27 },
    { date: '2017-07-17', value: 2459.14 },
    { date: '2017-07-18', value: 2460.61 },
    { date: '2017-07-19', value: 2473.83 },
    { date: '2017-07-20', value: 2473.45 },
    { date: '2017-07-21', value: 2472.54 },
    { date: '2017-07-24', value: 2469.91 },
    { date: '2017-07-25', value: 2477.13 },
    { date: '2017-07-26', value: 2477.83 },
    { date: '2017-07-27', value: 2475.42 },
    { date: '2017-07-28', value: 2472.1 },
    { date: '2017-07-31', value: 2470.3 },
    { date: '2017-08-01', value: 2476.35 },
    { date: '2017-08-02', value: 2477.57 },
    { date: '2017-08-03', value: 2472.16 },
    { date: '2017-08-04', value: 2476.83 },
    { date: '2017-08-07', value: 2480.91 },
    { date: '2017-08-08', value: 2474.92 },
    { date: '2017-08-09', value: 2474.02 },
    { date: '2017-08-10', value: 2438.21 },
    { date: '2017-08-11', value: 2441.32 },
    { date: '2017-08-14', value: 2465.84 },
    { date: '2017-08-15', value: 2464.61 },
    { date: '2017-08-16', value: 2468.11 },
    { date: '2017-08-17', value: 2430.01 },
    { date: '2017-08-18', value: 2425.55 },
    { date: '2017-08-21', value: 2428.37 },
    { date: '2017-08-22', value: 2452.51 },
    { date: '2017-08-23', value: 2444.04 },
    { date: '2017-08-24', value: 2438.97 },
    { date: '2017-08-25', value: 2443.05 },
    { date: '2017-08-28', value: 2444.24 },
    { date: '2017-08-29', value: 2446.3 },
    { date: '2017-08-30', value: 2457.59 },
    { date: '2017-08-31', value: 2471.65 },
    { date: '2017-09-01', value: 2476.55 },
    { date: '2017-09-05', value: 2457.85 },
    { date: '2017-09-06', value: 2465.54 },
    { date: '2017-09-07', value: 2465.1 },
    { date: '2017-09-08', value: 2461.43 },
    { date: '2017-09-11', value: 2488.11 },
    { date: '2017-09-12', value: 2496.48 },
    { date: '2017-09-13', value: 2498.37 },
    { date: '2017-09-14', value: 2495.62 },
    { date: '2017-09-15', value: 2500.23 },
    { date: '2017-09-18', value: 2503.87 },
    { date: '2017-09-19', value: 2506.65 },
    { date: '2017-09-20', value: 2508.24 },
    { date: '2017-09-21', value: 2500.6 },
    { date: '2017-09-22', value: 2502.22 },
    { date: '2017-09-25', value: 2496.66 },
    { date: '2017-09-26', value: 2496.84 },
    { date: '2017-09-27', value: 2507.04 },
    { date: '2017-09-28', value: 2510.06 },
    { date: '2017-09-29', value: 2519.36 },
    { date: '2017-10-02', value: 2529.12 },
    { date: '2017-10-03', value: 2534.58 },
    { date: '2017-10-04', value: 2537.74 },
    { date: '2017-10-05', value: 2552.07 },
    { date: '2017-10-06', value: 2549.33 },
    { date: '2017-10-09', value: 2544.73 },
    { date: '2017-10-10', value: 2550.64 },
    { date: '2017-10-11', value: 2555.24 },
    { date: '2017-10-12', value: 2550.93 },
    { date: '2017-10-13', value: 2553.17 },
    { date: '2017-10-16', value: 2557.64 },
    { date: '2017-10-17', value: 2559.36 },
    { date: '2017-10-18', value: 2561.26 },
    { date: '2017-10-19', value: 2562.1 },
    { date: '2017-10-20', value: 2575.21 },
    { date: '2017-10-23', value: 2564.98 },
    { date: '2017-10-24', value: 2569.13 },
    { date: '2017-10-25', value: 2557.15 },
    { date: '2017-10-26', value: 2560.4 },
    { date: '2017-10-27', value: 2581.07 },
    { date: '2017-10-30', value: 2572.83 },
    { date: '2017-10-31', value: 2575.26 },
    { date: '2017-11-01', value: 2579.36 },
    { date: '2017-11-02', value: 2579.85 },
    { date: '2017-11-03', value: 2587.84 },
    { date: '2017-11-06', value: 2591.13 },
    { date: '2017-11-07', value: 2590.64 },
    { date: '2017-11-08', value: 2594.38 },
    { date: '2017-11-09', value: 2584.62 },
    { date: '2017-11-10', value: 2582.3 },
    { date: '2017-11-13', value: 2584.84 },
    { date: '2017-11-14', value: 2578.87 },
    { date: '2017-11-15', value: 2564.62 },
    { date: '2017-11-16', value: 2585.64 },
    { date: '2017-11-17', value: 2578.85 },
    { date: '2017-11-20', value: 2582.14 },
    { date: '2017-11-21', value: 2599.03 },
    { date: '2017-11-22', value: 2597.08 },
    { date: '2017-11-24', value: 2602.42 },
    { date: '2017-11-27', value: 2601.42 },
    { date: '2017-11-28', value: 2627.04 },
    { date: '2017-11-29', value: 2626.07 },
    { date: '2017-11-30', value: 2647.58 },
    { date: '2017-12-01', value: 2642.22 },
    { date: '2017-12-04', value: 2639.44 },
    { date: '2017-12-05', value: 2629.57 },
    { date: '2017-12-06', value: 2629.27 },
    { date: '2017-12-07', value: 2636.98 },
    { date: '2017-12-08', value: 2651.5 },
    { date: '2017-12-11', value: 2659.99 },
    { date: '2017-12-12', value: 2664.11 },
    { date: '2017-12-13', value: 2662.85 },
    { date: '2017-12-14', value: 2652.01 },
    { date: '2017-12-15', value: 2675.81 },
    { date: '2017-12-18', value: 2690.16 },
    { date: '2017-12-19', value: 2681.47 },
    { date: '2017-12-20', value: 2679.25 },
    { date: '2017-12-21', value: 2684.57 },
    { date: '2017-12-22', value: 2683.34 },
    { date: '2017-12-26', value: 2680.5 },
    { date: '2017-12-27', value: 2682.62 },
    { date: '2017-12-28', value: 2687.54 },
    { date: '2017-12-29', value: 2673.61 },
    { date: '2018-01-02', value: 2695.81 },
    { date: '2018-01-03', value: 2713.06 },
    { date: '2018-01-04', value: 2723.99 },
    { date: '2018-01-05', value: 2743.15 },
    { date: '2018-01-08', value: 2747.71 },
    { date: '2018-01-09', value: 2751.29 },
    { date: '2018-01-10', value: 2748.23 },
    { date: '2018-01-11', value: 2767.56 },
    { date: '2018-01-12', value: 2786.24 },
    { date: '2018-01-16', value: 2776.42 },
    { date: '2018-01-17', value: 2802.56 },
    { date: '2018-01-18', value: 2798.03 },
    { date: '2018-01-19', value: 2810.3 },
    { date: '2018-01-22', value: 2832.97 },
    { date: '2018-01-23', value: 2839.13 },
    { date: '2018-01-24', value: 2837.54 },
    { date: '2018-01-25', value: 2839.25 },
    { date: '2018-01-26', value: 2872.87 },
    { date: '2018-01-29', value: 2853.53 },
    { date: '2018-01-30', value: 2822.43 },
    { date: '2018-01-31', value: 2823.81 },
    { date: '2018-02-01', value: 2821.98 },
    { date: '2018-02-02', value: 2762.13 },
    { date: '2018-02-05', value: 2648.94 },
    { date: '2018-02-06', value: 2695.14 },
    { date: '2018-02-07', value: 2681.66 },
    { date: '2018-02-08', value: 2581.0 },
    { date: '2018-02-09', value: 2619.55 },
    { date: '2018-02-12', value: 2656.0 },
    { date: '2018-02-13', value: 2662.94 },
    { date: '2018-02-14', value: 2698.63 },
    { date: '2018-02-15', value: 2731.2 },
    { date: '2018-02-16', value: 2732.22 },
    { date: '2018-02-20', value: 2716.26 },
    { date: '2018-02-21', value: 2701.33 },
    { date: '2018-02-22', value: 2703.96 },
    { date: '2018-02-23', value: 2747.3 },
    { date: '2018-02-26', value: 2779.6 },
    { date: '2018-02-27', value: 2744.28 },
    { date: '2018-02-28', value: 2713.83 },
    { date: '2018-03-01', value: 2677.67 },
    { date: '2018-03-02', value: 2691.25 },
    { date: '2018-03-05', value: 2720.94 },
    { date: '2018-03-06', value: 2728.12 },
    { date: '2018-03-07', value: 2726.8 },
    { date: '2018-03-08', value: 2738.97 },
    { date: '2018-03-09', value: 2786.57 },
    { date: '2018-03-12', value: 2783.02 },
    { date: '2018-03-13', value: 2765.31 },
    { date: '2018-03-14', value: 2749.48 },
    { date: '2018-03-15', value: 2747.33 },
    { date: '2018-03-16', value: 2752.01 },
    { date: '2018-03-19', value: 2712.92 },
    { date: '2018-03-20', value: 2716.94 },
    { date: '2018-03-21', value: 2711.93 },
    { date: '2018-03-22', value: 2643.69 },
    { date: '2018-03-23', value: 2588.26 },
    { date: '2018-03-26', value: 2658.55 },
    { date: '2018-03-27', value: 2612.62 },
    { date: '2018-03-28', value: 2605.0 },
    { date: '2018-03-29', value: 2640.87 },
    { date: '2018-04-02', value: 2581.88 },
    { date: '2018-04-03', value: 2614.45 },
    { date: '2018-04-04', value: 2644.69 },
    { date: '2018-04-05', value: 2662.84 },
    { date: '2018-04-06', value: 2604.47 },
    { date: '2018-04-09', value: 2613.16 },
    { date: '2018-04-10', value: 2656.87 },
    { date: '2018-04-11', value: 2642.19 },
    { date: '2018-04-12', value: 2663.99 },
    { date: '2018-04-13', value: 2656.3 },
    { date: '2018-04-16', value: 2677.84 },
    { date: '2018-04-17', value: 2706.39 },
    { date: '2018-04-18', value: 2708.64 },
    { date: '2018-04-19', value: 2693.13 },
    { date: '2018-04-20', value: 2670.14 },
    { date: '2018-04-23', value: 2670.29 },
    { date: '2018-04-24', value: 2634.56 },
    { date: '2018-04-25', value: 2639.4 },
    { date: '2018-04-26', value: 2666.94 },
    { date: '2018-04-27', value: 2669.91 },
    { date: '2018-04-30', value: 2648.05 },
    { date: '2018-05-01', value: 2654.8 },
    { date: '2018-05-02', value: 2635.67 },
    { date: '2018-05-03', value: 2629.73 },
    { date: '2018-05-04', value: 2663.42 },
    { date: '2018-05-07', value: 2672.63 },
    { date: '2018-05-08', value: 2671.92 },
    { date: '2018-05-09', value: 2697.79 },
    { date: '2018-05-10', value: 2723.07 },
    { date: '2018-05-11', value: 2727.72 },
    { date: '2018-05-14', value: 2730.13 },
    { date: '2018-05-15', value: 2711.45 },
    { date: '2018-05-16', value: 2722.46 },
    { date: '2018-05-17', value: 2720.13 },
    { date: '2018-05-18', value: 2712.97 },
    { date: '2018-05-21', value: 2733.01 },
    { date: '2018-05-22', value: 2724.44 },
    { date: '2018-05-23', value: 2733.29 },
    { date: '2018-05-24', value: 2727.76 },
    { date: '2018-05-25', value: 2721.33 },
    { date: '2018-05-29', value: 2689.86 },
    { date: '2018-05-30', value: 2724.01 },
    { date: '2018-05-31', value: 2705.27 },
    { date: '2018-06-01', value: 2734.62 },
    { date: '2018-06-04', value: 2746.87 },
    { date: '2018-06-05', value: 2748.8 },
    { date: '2018-06-06', value: 2772.35 },
    { date: '2018-06-07', value: 2770.37 },
    { date: '2018-06-08', value: 2779.03 },
    { date: '2018-06-11', value: 2782.0 },
    { date: '2018-06-12', value: 2786.85 },
    { date: '2018-06-13', value: 2775.63 },
    { date: '2018-06-14', value: 2782.49 },
    { date: '2018-06-15', value: 2779.66 },
    { date: '2018-06-18', value: 2773.75 },
    { date: '2018-06-19', value: 2762.59 },
    { date: '2018-06-20', value: 2767.32 },
    { date: '2018-06-21', value: 2749.76 },
    { date: '2018-06-22', value: 2754.88 },
    { date: '2018-06-25', value: 2717.07 },
    { date: '2018-06-26', value: 2723.06 },
    { date: '2018-06-27', value: 2699.63 },
    { date: '2018-06-28', value: 2716.31 },
    { date: '2018-06-29', value: 2718.37 },
    { date: '2018-07-02', value: 2726.71 },
    { date: '2018-07-03', value: 2713.22 },
    { date: '2018-07-05', value: 2736.61 },
    { date: '2018-07-06', value: 2759.82 },
    { date: '2018-07-09', value: 2784.17 },
    { date: '2018-07-10', value: 2793.84 },
    { date: '2018-07-11', value: 2774.02 },
    { date: '2018-07-12', value: 2798.29 },
    { date: '2018-07-13', value: 2801.31 },
    { date: '2018-07-16', value: 2798.43 },
    { date: '2018-07-17', value: 2809.55 },
    { date: '2018-07-18', value: 2815.62 },
    { date: '2018-07-19', value: 2804.49 },
    { date: '2018-07-20', value: 2801.83 },
    { date: '2018-07-23', value: 2806.98 },
    { date: '2018-07-24', value: 2820.4 },
    { date: '2018-07-25', value: 2846.07 },
    { date: '2018-07-26', value: 2837.44 },
    { date: '2018-07-27', value: 2818.82 },
    { date: '2018-07-30', value: 2802.6 },
    { date: '2018-07-31', value: 2816.29 },
    { date: '2018-08-01', value: 2813.36 },
    { date: '2018-08-02', value: 2827.22 },
    { date: '2018-08-03', value: 2840.35 },
    { date: '2018-08-06', value: 2850.4 },
    { date: '2018-08-07', value: 2858.45 },
    { date: '2018-08-08', value: 2857.7 },
    { date: '2018-08-09', value: 2853.58 },
    { date: '2018-08-10', value: 2833.28 },
    { date: '2018-08-13', value: 2821.93 },
    { date: '2018-08-14', value: 2839.96 },
    { date: '2018-08-15', value: 2818.37 },
    { date: '2018-08-16', value: 2840.69 },
    { date: '2018-08-17', value: 2850.13 },
    { date: '2018-08-20', value: 2857.05 },
    { date: '2018-08-21', value: 2862.96 },
    { date: '2018-08-22', value: 2861.82 },
    { date: '2018-08-23', value: 2856.98 },
    { date: '2018-08-24', value: 2874.69 },
    { date: '2018-08-27', value: 2896.74 },
    { date: '2018-08-28', value: 2897.52 },
    { date: '2018-08-29', value: 2914.04 },
    { date: '2018-08-30', value: 2901.13 },
    { date: '2018-08-31', value: 2901.52 },
    { date: '2018-09-04', value: 2896.72 },
    { date: '2018-09-05', value: 2888.6 },
    { date: '2018-09-06', value: 2878.05 },
    { date: '2018-09-07', value: 2871.68 },
    { date: '2018-09-10', value: 2877.13 },
    { date: '2018-09-11', value: 2887.89 },
    { date: '2018-09-12', value: 2888.92 },
    { date: '2018-09-13', value: 2904.18 },
    { date: '2018-09-14', value: 2904.98 },
    { date: '2018-09-17', value: 2888.8 },
    { date: '2018-09-18', value: 2904.31 },
    { date: '2018-09-19', value: 2907.95 },
    { date: '2018-09-20', value: 2930.75 },
    { date: '2018-09-21', value: 2929.67 },
    { date: '2018-09-24', value: 2919.37 },
    { date: '2018-09-25', value: 2915.56 },
    { date: '2018-09-26', value: 2905.97 },
    { date: '2018-09-27', value: 2914.0 },
    { date: '2018-09-28', value: 2913.98 },
    { date: '2018-10-01', value: 2924.59 },
    { date: '2018-10-02', value: 2923.43 },
    { date: '2018-10-03', value: 2925.51 },
    { date: '2018-10-04', value: 2901.61 },
    { date: '2018-10-05', value: 2885.57 },
    { date: '2018-10-08', value: 2884.43 },
    { date: '2018-10-09', value: 2880.34 },
    { date: '2018-10-10', value: 2785.68 },
    { date: '2018-10-11', value: 2728.37 },
    { date: '2018-10-12', value: 2767.13 },
    { date: '2018-10-15', value: 2750.79 },
    { date: '2018-10-16', value: 2809.92 },
    { date: '2018-10-17', value: 2809.21 },
    { date: '2018-10-18', value: 2768.78 },
    { date: '2018-10-19', value: 2767.78 },
    { date: '2018-10-22', value: 2755.88 },
    { date: '2018-10-23', value: 2740.69 },
    { date: '2018-10-24', value: 2656.1 },
    { date: '2018-10-25', value: 2705.57 },
    { date: '2018-10-26', value: 2658.69 },
    { date: '2018-10-29', value: 2641.25 },
    { date: '2018-10-30', value: 2682.63 },
    { date: '2018-10-31', value: 2711.74 },
    { date: '2018-11-01', value: 2740.37 },
    { date: '2018-11-02', value: 2723.06 },
    { date: '2018-11-05', value: 2738.31 },
    { date: '2018-11-06', value: 2755.45 },
    { date: '2018-11-07', value: 2813.89 },
    { date: '2018-11-08', value: 2806.83 },
    { date: '2018-11-09', value: 2781.01 },
    { date: '2018-11-12', value: 2726.22 },
    { date: '2018-11-13', value: 2722.18 },
    { date: '2018-11-14', value: 2701.58 },
    { date: '2018-11-15', value: 2730.2 },
    { date: '2018-11-16', value: 2736.27 },
    { date: '2018-11-19', value: 2690.73 },
    { date: '2018-11-20', value: 2641.89 },
    { date: '2018-11-21', value: 2649.93 },
    { date: '2018-11-23', value: 2632.56 },
    { date: '2018-11-26', value: 2673.45 },
    { date: '2018-11-27', value: 2682.17 },
    { date: '2018-11-28', value: 2743.79 },
    { date: '2018-11-29', value: 2737.76 },
    { date: '2018-11-30', value: 2760.17 },
    { date: '2018-12-03', value: 2790.37 },
    { date: '2018-12-04', value: 2700.06 },
    { date: '2018-12-06', value: 2695.95 },
    { date: '2018-12-07', value: 2633.08 },
    { date: '2018-12-10', value: 2637.72 },
    { date: '2018-12-11', value: 2636.78 },
    { date: '2018-12-12', value: 2651.07 },
    { date: '2018-12-13', value: 2650.54 },
    { date: '2018-12-14', value: 2599.95 },
    { date: '2018-12-17', value: 2545.94 },
    { date: '2018-12-18', value: 2546.16 },
    { date: '2018-12-19', value: 2506.96 },
    { date: '2018-12-20', value: 2467.42 },
    { date: '2018-12-21', value: 2416.62 },
    { date: '2018-12-24', value: 2351.1 },
    { date: '2018-12-26', value: 2467.7 },
    { date: '2018-12-27', value: 2488.83 },
    { date: '2018-12-28', value: 2485.74 },
    { date: '2018-12-31', value: 2506.85 },
    { date: '2019-01-02', value: 2510.03 },
    { date: '2019-01-03', value: 2447.89 },
    { date: '2019-01-04', value: 2531.94 },
    { date: '2019-01-07', value: 2549.69 },
    { date: '2019-01-08', value: 2574.41 },
    { date: '2019-01-09', value: 2584.96 },
    { date: '2019-01-10', value: 2596.64 },
    { date: '2019-01-11', value: 2596.26 },
    { date: '2019-01-14', value: 2582.61 },
    { date: '2019-01-15', value: 2610.3 },
    { date: '2019-01-16', value: 2616.1 },
    { date: '2019-01-17', value: 2635.96 },
    { date: '2019-01-18', value: 2670.71 },
    { date: '2019-01-22', value: 2632.9 },
    { date: '2019-01-23', value: 2638.7 },
    { date: '2019-01-24', value: 2642.33 },
    { date: '2019-01-25', value: 2664.76 },
    { date: '2019-01-28', value: 2643.85 },
    { date: '2019-01-29', value: 2640.0 },
    { date: '2019-01-30', value: 2681.05 },
    { date: '2019-01-31', value: 2704.1 },
    { date: '2019-02-01', value: 2706.53 },
    { date: '2019-02-04', value: 2724.87 },
    { date: '2019-02-05', value: 2737.7 },
    { date: '2019-02-06', value: 2731.61 },
    { date: '2019-02-07', value: 2706.05 },
    { date: '2019-02-08', value: 2707.88 },
    { date: '2019-02-11', value: 2709.8 },
    { date: '2019-02-12', value: 2744.73 },
    { date: '2019-02-13', value: 2753.03 },
    { date: '2019-02-14', value: 2745.73 },
    { date: '2019-02-15', value: 2775.6 },
    { date: '2019-02-19', value: 2779.76 },
    { date: '2019-02-20', value: 2784.7 },
    { date: '2019-02-21', value: 2774.88 },
    { date: '2019-02-22', value: 2792.67 },
    { date: '2019-02-25', value: 2796.11 },
    { date: '2019-02-26', value: 2793.9 },
    { date: '2019-02-27', value: 2792.38 },
    { date: '2019-02-28', value: 2784.49 },
    { date: '2019-03-01', value: 2803.69 },
    { date: '2019-03-04', value: 2792.81 },
    { date: '2019-03-05', value: 2789.65 },
    { date: '2019-03-06', value: 2771.45 },
    { date: '2019-03-07', value: 2748.93 },
    { date: '2019-03-08', value: 2743.07 },
    { date: '2019-03-11', value: 2783.3 },
    { date: '2019-03-12', value: 2791.52 },
    { date: '2019-03-13', value: 2810.92 },
    { date: '2019-03-14', value: 2808.48 },
    { date: '2019-03-15', value: 2822.48 },
    { date: '2019-03-18', value: 2832.94 },
    { date: '2019-03-19', value: 2832.57 },
    { date: '2019-03-20', value: 2824.23 },
    { date: '2019-03-21', value: 2854.88 },
    { date: '2019-03-22', value: 2800.71 },
    { date: '2019-03-25', value: 2798.36 },
    { date: '2019-03-26', value: 2818.46 },
    { date: '2019-03-27', value: 2805.37 },
    { date: '2019-03-28', value: 2815.44 },
    { date: '2019-03-29', value: 2834.4 },
    { date: '2019-04-01', value: 2867.19 },
    { date: '2019-04-02', value: 2867.24 },
    { date: '2019-04-03', value: 2873.4 },
    { date: '2019-04-04', value: 2879.39 },
    { date: '2019-04-05', value: 2892.74 },
    { date: '2019-04-08', value: 2895.77 },
    { date: '2019-04-09', value: 2878.2 },
    { date: '2019-04-10', value: 2888.21 },
    { date: '2019-04-11', value: 2888.32 },
    { date: '2019-04-12', value: 2907.41 },
    { date: '2019-04-15', value: 2905.58 },
    { date: '2019-04-16', value: 2907.06 },
    { date: '2019-04-17', value: 2900.45 },
    { date: '2019-04-18', value: 2905.03 },
    { date: '2019-04-22', value: 2907.97 },
    { date: '2019-04-23', value: 2933.68 },
    { date: '2019-04-24', value: 2927.25 },
    { date: '2019-04-25', value: 2926.17 },
    { date: '2019-04-26', value: 2939.88 },
    { date: '2019-04-29', value: 2943.03 },
    { date: '2019-04-30', value: 2945.83 },
    { date: '2019-05-01', value: 2923.73 },
    { date: '2019-05-02', value: 2917.52 },
    { date: '2019-05-03', value: 2945.64 },
    { date: '2019-05-06', value: 2932.47 },
    { date: '2019-05-07', value: 2884.05 },
    { date: '2019-05-08', value: 2879.42 },
    { date: '2019-05-09', value: 2870.72 },
    { date: '2019-05-10', value: 2881.4 },
    { date: '2019-05-13', value: 2811.87 },
    { date: '2019-05-14', value: 2834.41 },
    { date: '2019-05-15', value: 2850.96 },
    { date: '2019-05-16', value: 2876.32 },
    { date: '2019-05-17', value: 2859.53 },
    { date: '2019-05-20', value: 2840.23 },
    { date: '2019-05-21', value: 2864.36 },
    { date: '2019-05-22', value: 2856.27 },
    { date: '2019-05-23', value: 2822.24 },
    { date: '2019-05-24', value: 2826.06 },
    { date: '2019-05-28', value: 2802.39 },
    { date: '2019-05-29', value: 2783.02 },
    { date: '2019-05-30', value: 2788.86 },
    { date: '2019-05-31', value: 2752.06 },
    { date: '2019-06-03', value: 2744.45 },
    { date: '2019-06-04', value: 2803.27 },
    { date: '2019-06-05', value: 2826.15 },
    { date: '2019-06-06', value: 2843.49 },
    { date: '2019-06-07', value: 2873.34 },
    { date: '2019-06-10', value: 2886.73 },
    { date: '2019-06-11', value: 2885.72 },
    { date: '2019-06-12', value: 2879.84 },
    { date: '2019-06-13', value: 2891.64 },
    { date: '2019-06-14', value: 2886.98 },
    { date: '2019-06-17', value: 2889.67 },
    { date: '2019-06-18', value: 2917.75 },
    { date: '2019-06-19', value: 2926.46 },
    { date: '2019-06-20', value: 2954.18 },
    { date: '2019-06-21', value: 2950.46 },
    { date: '2019-06-24', value: 2945.35 },
    { date: '2019-06-25', value: 2917.38 },
    { date: '2019-06-26', value: 2913.78 },
    { date: '2019-06-27', value: 2924.92 },
    { date: '2019-06-28', value: 2941.76 },
    { date: '2019-07-01', value: 2964.33 },
    { date: '2019-07-02', value: 2973.01 },
    { date: '2019-07-03', value: 2995.82 },
    { date: '2019-07-05', value: 2990.41 },
    { date: '2019-07-08', value: 2975.95 },
    { date: '2019-07-09', value: 2979.63 },
    { date: '2019-07-10', value: 2993.07 },
    { date: '2019-07-11', value: 2999.91 },
    { date: '2019-07-12', value: 3013.77 },
    { date: '2019-07-15', value: 3014.3 },
    { date: '2019-07-16', value: 3004.04 },
    { date: '2019-07-17', value: 2984.42 },
    { date: '2019-07-18', value: 2995.11 },
    { date: '2019-07-19', value: 2976.61 },
    { date: '2019-07-22', value: 2985.03 },
    { date: '2019-07-23', value: 3005.47 },
    { date: '2019-07-24', value: 3019.56 },
    { date: '2019-07-25', value: 3003.67 },
    { date: '2019-07-26', value: 3025.86 },
    { date: '2019-07-29', value: 3020.97 },
    { date: '2019-07-30', value: 3013.18 },
    { date: '2019-07-31', value: 2980.38 },
    { date: '2019-08-01', value: 2953.56 },
    { date: '2019-08-02', value: 2932.05 },
    { date: '2019-08-05', value: 2844.74 },
    { date: '2019-08-06', value: 2881.77 },
    { date: '2019-08-07', value: 2883.98 },
    { date: '2019-08-08', value: 2938.09 },
    { date: '2019-08-09', value: 2918.65 },
    { date: '2019-08-12', value: 2883.75 },
    { date: '2019-08-13', value: 2926.32 },
    { date: '2019-08-14', value: 2840.6 },
    { date: '2019-08-15', value: 2847.6 },
    { date: '2019-08-16', value: 2888.68 },
    { date: '2019-08-19', value: 2923.65 },
    { date: '2019-08-20', value: 2900.51 },
    { date: '2019-08-21', value: 2924.43 },
    { date: '2019-08-22', value: 2922.95 },
    { date: '2019-08-23', value: 2847.11 },
    { date: '2019-08-26', value: 2878.38 },
    { date: '2019-08-27', value: 2869.16 },
    { date: '2019-08-28', value: 2887.94 },
    { date: '2019-08-29', value: 2924.58 },
    { date: '2019-08-30', value: 2926.46 },
    { date: '2019-09-03', value: 2906.27 },
    { date: '2019-09-04', value: 2937.78 },
    { date: '2019-09-05', value: 2976.0 },
    { date: '2019-09-06', value: 2978.71 },
    { date: '2019-09-09', value: 2978.43 },
    { date: '2019-09-10', value: 2979.39 },
    { date: '2019-09-11', value: 3000.93 },
    { date: '2019-09-12', value: 3009.57 },
    { date: '2019-09-13', value: 3007.39 },
    { date: '2019-09-16', value: 2997.96 },
    { date: '2019-09-17', value: 3005.7 },
    { date: '2019-09-18', value: 3006.73 },
    { date: '2019-09-19', value: 3006.79 },
    { date: '2019-09-20', value: 2992.07 },
    { date: '2019-09-23', value: 2991.78 },
    { date: '2019-09-24', value: 2966.6 },
    { date: '2019-09-25', value: 2984.87 },
    { date: '2019-09-26', value: 2977.62 },
    { date: '2019-09-27', value: 2961.79 },
    { date: '2019-09-30', value: 2976.74 },
    { date: '2019-10-01', value: 2940.25 },
    { date: '2019-10-02', value: 2887.61 },
    { date: '2019-10-03', value: 2910.63 },
    { date: '2019-10-04', value: 2952.01 },
    { date: '2019-10-07', value: 2938.79 },
    { date: '2019-10-08', value: 2893.06 },
    { date: '2019-10-09', value: 2919.4 },
    { date: '2019-10-10', value: 2938.13 },
    { date: '2019-10-11', value: 2970.27 },
    { date: '2019-10-14', value: 2966.15 },
    { date: '2019-10-15', value: 2995.68 },
    { date: '2019-10-16', value: 2989.69 },
    { date: '2019-10-17', value: 2997.95 },
    { date: '2019-10-18', value: 2986.2 },
    { date: '2019-10-21', value: 3006.72 },
    { date: '2019-10-22', value: 2995.99 },
    { date: '2019-10-23', value: 3004.52 },
    { date: '2019-10-24', value: 3010.29 },
    { date: '2019-10-25', value: 3022.55 },
    { date: '2019-10-28', value: 3039.42 },
    { date: '2019-10-29', value: 3036.89 },
    { date: '2019-10-30', value: 3046.77 },
    { date: '2019-10-31', value: 3037.56 },
    { date: '2019-11-01', value: 3066.91 },
    { date: '2019-11-04', value: 3078.27 },
    { date: '2019-11-05', value: 3074.62 },
    { date: '2019-11-06', value: 3076.78 },
    { date: '2019-11-07', value: 3085.18 },
    { date: '2019-11-08', value: 3093.08 },
    { date: '2019-11-11', value: 3087.01 },
    { date: '2019-11-12', value: 3091.84 },
    { date: '2019-11-13', value: 3094.04 },
    { date: '2019-11-14', value: 3096.63 },
    { date: '2019-11-15', value: 3120.46 },
    { date: '2019-11-18', value: 3122.03 },
    { date: '2019-11-19', value: 3120.18 },
    { date: '2019-11-20', value: 3108.46 },
    { date: '2019-11-21', value: 3103.54 },
    { date: '2019-11-22', value: 3110.29 },
    { date: '2019-11-25', value: 3133.64 },
    { date: '2019-11-26', value: 3140.52 },
    { date: '2019-11-27', value: 3153.63 },
    { date: '2019-11-29', value: 3140.98 },
    { date: '2019-12-02', value: 3113.87 },
    { date: '2019-12-03', value: 3093.2 },
    { date: '2019-12-04', value: 3112.76 },
    { date: '2019-12-05', value: 3117.43 },
    { date: '2019-12-06', value: 3145.91 },
    { date: '2019-12-09', value: 3135.96 },
    { date: '2019-12-10', value: 3132.52 },
    { date: '2019-12-11', value: 3141.63 },
    { date: '2019-12-12', value: 3168.57 },
    { date: '2019-12-13', value: 3168.8 },
    { date: '2019-12-16', value: 3191.45 },
    { date: '2019-12-17', value: 3192.52 },
    { date: '2019-12-18', value: 3191.14 },
    { date: '2019-12-19', value: 3205.37 },
    { date: '2019-12-20', value: 3221.22 },
    { date: '2019-12-23', value: 3224.01 },
    { date: '2019-12-24', value: 3223.38 },
    { date: '2019-12-26', value: 3239.91 },
    { date: '2019-12-27', value: 3240.02 },
    { date: '2019-12-30', value: 3221.29 },
    { date: '2019-12-31', value: 3230.78 },
    { date: '2020-01-02', value: 3257.85 },
    { date: '2020-01-03', value: 3234.85 },
    { date: '2020-01-06', value: 3246.28 },
    { date: '2020-01-07', value: 3237.18 },
    { date: '2020-01-08', value: 3253.05 },
    { date: '2020-01-09', value: 3274.7 },
    { date: '2020-01-10', value: 3265.35 },
    { date: '2020-01-13', value: 3288.13 },
    { date: '2020-01-14', value: 3283.15 },
    { date: '2020-01-15', value: 3289.29 },
    { date: '2020-01-16', value: 3316.81 },
    { date: '2020-01-17', value: 3329.62 },
    { date: '2020-01-21', value: 3320.79 },
    { date: '2020-01-22', value: 3321.75 },
    { date: '2020-01-23', value: 3325.54 },
    { date: '2020-01-24', value: 3295.47 },
    { date: '2020-01-27', value: 3243.63 },
    { date: '2020-01-28', value: 3276.24 },
    { date: '2020-01-29', value: 3273.4 },
    { date: '2020-01-30', value: 3283.66 },
    { date: '2020-01-31', value: 3225.52 },
    { date: '2020-02-03', value: 3248.92 },
    { date: '2020-02-04', value: 3297.59 },
    { date: '2020-02-05', value: 3334.69 },
    { date: '2020-02-06', value: 3345.78 },
    { date: '2020-02-07', value: 3327.71 },
    { date: '2020-02-10', value: 3352.09 },
    { date: '2020-02-11', value: 3357.75 },
    { date: '2020-02-12', value: 3379.45 },
    { date: '2020-02-13', value: 3373.94 },
    { date: '2020-02-14', value: 3380.16 },
    { date: '2020-02-18', value: 3370.29 },
    { date: '2020-02-19', value: 3386.15 },
    { date: '2020-02-20', value: 3373.23 },
    { date: '2020-02-21', value: 3337.75 },
    { date: '2020-02-24', value: 3225.89 },
    { date: '2020-02-25', value: 3128.21 },
    { date: '2020-02-26', value: 3116.39 },
    { date: '2020-02-27', value: 2978.76 },
    { date: '2020-02-28', value: 2954.22 },
    { date: '2020-03-02', value: 3090.23 },
    { date: '2020-03-03', value: 3003.37 },
    { date: '2020-03-04', value: 3130.12 },
    { date: '2020-03-05', value: 3023.94 },
    { date: '2020-03-06', value: 2972.37 },
    { date: '2020-03-09', value: 2746.56 },
    { date: '2020-03-10', value: 2882.23 },
    { date: '2020-03-11', value: 2741.38 },
    { date: '2020-03-12', value: 2480.64 },
    { date: '2020-03-13', value: 2711.02 },
    { date: '2020-03-16', value: 2386.13 },
    { date: '2020-03-17', value: 2529.19 },
    { date: '2020-03-18', value: 2398.1 },
    { date: '2020-03-19', value: 2409.39 },
    { date: '2020-03-20', value: 2304.92 },
    { date: '2020-03-23', value: 2237.4 },
    { date: '2020-03-24', value: 2447.33 },
    { date: '2020-03-25', value: 2475.56 },
    { date: '2020-03-26', value: 2630.07 },
    { date: '2020-03-27', value: 2541.47 },
    { date: '2020-03-30', value: 2626.65 },
    { date: '2020-03-31', value: 2584.59 },
    { date: '2020-04-01', value: 2470.5 },
    { date: '2020-04-02', value: 2526.9 },
    { date: '2020-04-03', value: 2488.65 },
    { date: '2020-04-06', value: 2663.68 },
    { date: '2020-04-07', value: 2659.41 },
    { date: '2020-04-08', value: 2749.98 },
    { date: '2020-04-09', value: 2789.82 },
    { date: '2020-04-13', value: 2761.63 },
    { date: '2020-04-14', value: 2846.06 },
    { date: '2020-04-15', value: 2783.36 },
    { date: '2020-04-16', value: 2799.55 },
    { date: '2020-04-17', value: 2874.56 },
    { date: '2020-04-20', value: 2823.16 },
    { date: '2020-04-21', value: 2736.56 },
    { date: '2020-04-22', value: 2799.31 },
    { date: '2020-04-23', value: 2797.8 },
    { date: '2020-04-24', value: 2836.74 },
    { date: '2020-04-27', value: 2878.48 },
    { date: '2020-04-28', value: 2863.39 },
    { date: '2020-04-29', value: 2939.51 },
    { date: '2020-04-30', value: 2912.43 },
    { date: '2020-05-01', value: 2830.71 },
    { date: '2020-05-04', value: 2842.74 },
    { date: '2020-05-05', value: 2868.44 },
    { date: '2020-05-06', value: 2848.42 },
    { date: '2020-05-07', value: 2881.19 },
    { date: '2020-05-08', value: 2929.8 },
    { date: '2020-05-11', value: 2930.32 },
    { date: '2020-05-12', value: 2870.12 },
    { date: '2020-05-13', value: 2820.0 },
    { date: '2020-05-14', value: 2852.5 },
    { date: '2020-05-15', value: 2863.7 },
    { date: '2020-05-18', value: 2953.91 },
    { date: '2020-05-19', value: 2922.94 },
    { date: '2020-05-20', value: 2971.61 },
    { date: '2020-05-21', value: 2948.51 },
    { date: '2020-05-22', value: 2955.45 },
    { date: '2020-05-26', value: 2991.77 },
    { date: '2020-05-27', value: 3036.13 },
    { date: '2020-05-28', value: 3029.73 },
    { date: '2020-05-29', value: 3044.31 },
    { date: '2020-06-01', value: 3055.73 },
    { date: '2020-06-02', value: 3080.82 },
    { date: '2020-06-03', value: 3122.87 },
    { date: '2020-06-04', value: 3112.35 },
    { date: '2020-06-05', value: 3193.93 },
    { date: '2020-06-08', value: 3232.39 },
    { date: '2020-06-09', value: 3207.18 },
    { date: '2020-06-10', value: 3190.14 },
    { date: '2020-06-11', value: 3002.1 },
    { date: '2020-06-12', value: 3041.31 },
    { date: '2020-06-15', value: 3066.59 },
    { date: '2020-06-16', value: 3124.74 },
    { date: '2020-06-17', value: 3113.49 },
    { date: '2020-06-18', value: 3115.34 },
    { date: '2020-06-19', value: 3097.74 },
    { date: '2020-06-22', value: 3117.86 },
    { date: '2020-06-23', value: 3131.29 },
    { date: '2020-06-24', value: 3050.33 },
    { date: '2020-06-25', value: 3083.76 },
    { date: '2020-06-26', value: 3009.05 },
    { date: '2020-06-29', value: 3053.24 },
    { date: '2020-06-30', value: 3100.29 },
    { date: '2020-07-01', value: 3115.86 },
    { date: '2020-07-02', value: 3130.01 },
    { date: '2020-07-06', value: 3179.72 },
    { date: '2020-07-07', value: 3145.32 },
    { date: '2020-07-08', value: 3169.94 },
    { date: '2020-07-09', value: 3152.05 },
    { date: '2020-07-10', value: 3185.04 },
    { date: '2020-07-13', value: 3155.22 },
    { date: '2020-07-14', value: 3197.52 },
    { date: '2020-07-15', value: 3226.56 },
    { date: '2020-07-16', value: 3215.57 },
    { date: '2020-07-17', value: 3224.73 },
    { date: '2020-07-20', value: 3251.84 },
    { date: '2020-07-21', value: 3257.3 },
    { date: '2020-07-22', value: 3276.02 },
    { date: '2020-07-23', value: 3235.66 },
    { date: '2020-07-24', value: 3215.63 },
    { date: '2020-07-27', value: 3239.41 },
    { date: '2020-07-28', value: 3218.44 },
    { date: '2020-07-29', value: 3258.44 },
    { date: '2020-07-30', value: 3246.22 },
    { date: '2020-07-31', value: 3271.12 },
    { date: '2020-08-03', value: 3294.61 },
    { date: '2020-08-04', value: 3306.51 },
    { date: '2020-08-05', value: 3327.77 },
    { date: '2020-08-06', value: 3349.16 },
    { date: '2020-08-07', value: 3351.28 },
    { date: '2020-08-10', value: 3360.47 },
    { date: '2020-08-11', value: 3333.69 },
    { date: '2020-08-12', value: 3380.35 },
    { date: '2020-08-13', value: 3373.43 },
    { date: '2020-08-14', value: 3372.85 },
    { date: '2020-08-17', value: 3381.99 },
    { date: '2020-08-18', value: 3389.78 },
    { date: '2020-08-19', value: 3374.85 },
    { date: '2020-08-20', value: 3385.51 },
    { date: '2020-08-21', value: 3397.16 },
    { date: '2020-08-24', value: 3431.28 },
    { date: '2020-08-25', value: 3443.62 },
    { date: '2020-08-26', value: 3478.73 },
    { date: '2020-08-27', value: 3484.55 },
    { date: '2020-08-28', value: 3508.01 },
    { date: '2020-08-31', value: 3500.31 },
    { date: '2020-09-01', value: 3526.65 },
    { date: '2020-09-02', value: 3580.84 },
    { date: '2020-09-03', value: 3455.06 },
    { date: '2020-09-04', value: 3426.96 },
    { date: '2020-09-08', value: 3331.84 },
    { date: '2020-09-09', value: 3398.96 },
    { date: '2020-09-10', value: 3339.19 },
    { date: '2020-09-11', value: 3340.97 },
    { date: '2020-09-14', value: 3383.54 },
    { date: '2020-09-15', value: 3401.2 },
    { date: '2020-09-16', value: 3385.49 },
    { date: '2020-09-17', value: 3357.01 },
    { date: '2020-09-18', value: 3319.47 },
    { date: '2020-09-21', value: 3281.06 },
    { date: '2020-09-22', value: 3315.57 },
    { date: '2020-09-23', value: 3236.92 },
    { date: '2020-09-24', value: 3246.59 },
    { date: '2020-09-25', value: 3298.46 },
    { date: '2020-09-28', value: 3351.6 },
    { date: '2020-09-29', value: 3335.47 },
    { date: '2020-09-30', value: 3363.0 },
    { date: '2020-10-01', value: 3380.8 },
    { date: '2020-10-02', value: 3348.44 },
    { date: '2020-10-05', value: 3408.63 },
    { date: '2020-10-06', value: 3360.95 },
    { date: '2020-10-07', value: 3419.45 },
    { date: '2020-10-08', value: 3446.83 },
    { date: '2020-10-09', value: 3477.13 },
    { date: '2020-10-12', value: 3534.22 },
    { date: '2020-10-13', value: 3511.93 },
    { date: '2020-10-14', value: 3488.67 },
    { date: '2020-10-15', value: 3483.34 },
    { date: '2020-10-16', value: 3483.81 },
    { date: '2020-10-19', value: 3426.92 },
    { date: '2020-10-20', value: 3443.12 },
    { date: '2020-10-21', value: 3435.56 },
    { date: '2020-10-22', value: 3453.49 },
    { date: '2020-10-23', value: 3465.39 },
    { date: '2020-10-26', value: 3400.97 },
    { date: '2020-10-27', value: 3390.68 },
    { date: '2020-10-28', value: 3271.03 },
    { date: '2020-10-29', value: 3310.11 },
    { date: '2020-10-30', value: 3269.96 },
    { date: '2020-11-02', value: 3310.24 },
    { date: '2020-11-03', value: 3369.16 },
    { date: '2020-11-04', value: 3443.44 },
    { date: '2020-11-05', value: 3510.45 },
    { date: '2020-11-06', value: 3509.44 },
    { date: '2020-11-09', value: 3550.5 },
    { date: '2020-11-10', value: 3545.53 },
    { date: '2020-11-11', value: 3572.66 },
    { date: '2020-11-12', value: 3537.01 },
    { date: '2020-11-13', value: 3585.15 },
    { date: '2020-11-16', value: 3626.91 },
    { date: '2020-11-17', value: 3609.53 },
    { date: '2020-11-18', value: 3567.79 },
    { date: '2020-11-19', value: 3581.87 },
    { date: '2020-11-20', value: 3557.54 },
    { date: '2020-11-23', value: 3577.59 },
    { date: '2020-11-24', value: 3635.41 },
    { date: '2020-11-25', value: 3629.65 },
    { date: '2020-11-27', value: 3638.35 },
    { date: '2020-11-30', value: 3621.63 },
    { date: '2020-12-01', value: 3662.45 },
    { date: '2020-12-02', value: 3669.01 },
    { date: '2020-12-03', value: 3666.72 },
    { date: '2020-12-04', value: 3699.12 },
    { date: '2020-12-07', value: 3691.96 },
    { date: '2020-12-08', value: 3702.25 },
    { date: '2020-12-09', value: 3672.82 },
    { date: '2020-12-10', value: 3668.1 },
    { date: '2020-12-11', value: 3663.46 },
    { date: '2020-12-14', value: 3647.49 },
    { date: '2020-12-15', value: 3694.62 },
    { date: '2020-12-16', value: 3701.17 },
    { date: '2020-12-17', value: 3722.48 },
    { date: '2020-12-18', value: 3709.41 },
    { date: '2020-12-21', value: 3694.92 },
    { date: '2020-12-22', value: 3687.26 },
    { date: '2020-12-23', value: 3690.01 },
    { date: '2020-12-24', value: 3703.06 },
    { date: '2020-12-28', value: 3735.36 },
    { date: '2020-12-29', value: 3727.04 },
    { date: '2020-12-30', value: 3732.04 },
    { date: '2020-12-31', value: 3756.07 },
    { date: '2021-01-04', value: 3700.65 },
    { date: '2021-01-05', value: 3726.86 },
    { date: '2021-01-06', value: 3748.14 },
    { date: '2021-01-07', value: 3803.79 },
    { date: '2021-01-08', value: 3824.68 },
    { date: '2021-01-11', value: 3799.61 },
    { date: '2021-01-12', value: 3801.19 },
    { date: '2021-01-13', value: 3809.84 },
    { date: '2021-01-14', value: 3795.54 },
    { date: '2021-01-15', value: 3768.25 },
    { date: '2021-01-19', value: 3798.91 },
    { date: '2021-01-20', value: 3851.85 },
    { date: '2021-01-21', value: 3853.07 },
    { date: '2021-01-22', value: 3841.47 },
    { date: '2021-01-25', value: 3855.36 },
    { date: '2021-01-26', value: 3849.62 },
    { date: '2021-01-27', value: 3750.77 },
    { date: '2021-01-28', value: 3787.38 },
    { date: '2021-01-29', value: 3714.24 },
    { date: '2021-02-01', value: 3773.86 },
    { date: '2021-02-02', value: 3826.31 },
    { date: '2021-02-03', value: 3830.17 },
    { date: '2021-02-04', value: 3871.74 },
    { date: '2021-02-05', value: 3886.83 },
    { date: '2021-02-08', value: 3915.59 },
    { date: '2021-02-09', value: 3911.23 },
    { date: '2021-02-10', value: 3909.88 },
    { date: '2021-02-11', value: 3916.38 },
    { date: '2021-02-12', value: 3934.83 },
    { date: '2021-02-16', value: 3932.59 },
    { date: '2021-02-17', value: 3931.33 },
    { date: '2021-02-18', value: 3913.97 },
    { date: '2021-02-19', value: 3906.71 },
    { date: '2021-02-22', value: 3876.5 },
    { date: '2021-02-23', value: 3881.37 },
    { date: '2021-02-24', value: 3925.43 },
    { date: '2021-02-25', value: 3829.34 },
    { date: '2021-02-26', value: 3811.15 },
    { date: '2021-03-01', value: 3901.82 },
    { date: '2021-03-02', value: 3870.29 },
    { date: '2021-03-03', value: 3819.72 },
    { date: '2021-03-04', value: 3768.47 },
    { date: '2021-03-05', value: 3841.94 },
    { date: '2021-03-08', value: 3821.35 },
    { date: '2021-03-09', value: 3875.44 },
    { date: '2021-03-10', value: 3898.81 },
    { date: '2021-03-11', value: 3939.34 },
    { date: '2021-03-12', value: 3943.34 },
    { date: '2021-03-15', value: 3968.94 },
    { date: '2021-03-16', value: 3962.71 },
    { date: '2021-03-17', value: 3974.12 },
    { date: '2021-03-18', value: 3915.46 },
    { date: '2021-03-19', value: 3913.1 },
    { date: '2021-03-22', value: 3940.59 },
    { date: '2021-03-23', value: 3910.52 },
    { date: '2021-03-24', value: 3889.14 },
    { date: '2021-03-25', value: 3909.52 },
    { date: '2021-03-26', value: 3974.54 },
    { date: '2021-03-29', value: 3971.09 },
    { date: '2021-03-30', value: 3958.55 },
    { date: '2021-03-31', value: 3972.89 },
    { date: '2021-04-01', value: 4019.87 },
    { date: '2021-04-05', value: 4077.91 },
    { date: '2021-04-06', value: 4073.94 },
    { date: '2021-04-07', value: 4079.95 },
    { date: '2021-04-08', value: 4097.17 },
    { date: '2021-04-09', value: 4128.8 },
    { date: '2021-04-12', value: 4127.99 },
    { date: '2021-04-13', value: 4141.59 },
    { date: '2021-04-14', value: 4124.66 },
    { date: '2021-04-15', value: 4170.42 },
    { date: '2021-04-16', value: 4185.47 },
    { date: '2021-04-19', value: 4163.26 },
    { date: '2021-04-20', value: 4134.94 },
    { date: '2021-04-21', value: 4173.42 },
    { date: '2021-04-22', value: 4134.98 },
    { date: '2021-04-23', value: 4180.17 },
    { date: '2021-04-26', value: 4187.62 },
    { date: '2021-04-27', value: 4186.72 },
    { date: '2021-04-28', value: 4183.18 },
    { date: '2021-04-29', value: 4211.47 },
    { date: '2021-04-30', value: 4181.17 },
    { date: '2021-05-03', value: 4192.66 },
    { date: '2021-05-04', value: 4164.66 },
    { date: '2021-05-05', value: 4167.59 },
    { date: '2021-05-06', value: 4201.62 },
    { date: '2021-05-07', value: 4232.6 },
    { date: '2021-05-10', value: 4188.43 },
    { date: '2021-05-11', value: 4152.1 },
    { date: '2021-05-12', value: 4063.04 },
    { date: '2021-05-13', value: 4112.5 },
    { date: '2021-05-14', value: 4173.85 },
    { date: '2021-05-17', value: 4163.29 },
    { date: '2021-05-18', value: 4127.83 },
    { date: '2021-05-19', value: 4115.68 },
    { date: '2021-05-20', value: 4159.12 },
    { date: '2021-05-21', value: 4155.86 },
    { date: '2021-05-24', value: 4197.05 },
    { date: '2021-05-25', value: 4188.13 },
    { date: '2021-05-26', value: 4195.99 },
    { date: '2021-05-27', value: 4200.88 },
    { date: '2021-05-28', value: 4204.11 },
    { date: '2021-06-01', value: 4202.04 },
    { date: '2021-06-02', value: 4208.12 },
    { date: '2021-06-03', value: 4192.85 },
    { date: '2021-06-04', value: 4229.89 },
    { date: '2021-06-07', value: 4226.52 },
    { date: '2021-06-08', value: 4227.26 },
    { date: '2021-06-09', value: 4219.55 },
    { date: '2021-06-10', value: 4239.18 },
    { date: '2021-06-11', value: 4247.44 },
    { date: '2021-06-14', value: 4255.15 },
    { date: '2021-06-15', value: 4246.59 },
    { date: '2021-06-16', value: 4223.7 },
    { date: '2021-06-17', value: 4221.86 },
    { date: '2021-06-18', value: 4166.45 },
    { date: '2021-06-21', value: 4224.79 },
    { date: '2021-06-22', value: 4246.44 },
    { date: '2021-06-23', value: 4241.84 },
    { date: '2021-06-24', value: 4266.49 },
    { date: '2021-06-25', value: 4280.7 },
    { date: '2021-06-28', value: 4290.61 },
    { date: '2021-06-29', value: 4291.8 },
    { date: '2021-06-30', value: 4297.5 },
    { date: '2021-07-01', value: 4319.94 },
    { date: '2021-07-02', value: 4352.34 },
    { date: '2021-07-06', value: 4343.54 },
    { date: '2021-07-07', value: 4358.13 },
    { date: '2021-07-08', value: 4320.82 },
    { date: '2021-07-09', value: 4369.55 },
    { date: '2021-07-12', value: 4384.63 },
    { date: '2021-07-13', value: 4369.21 },
    { date: '2021-07-14', value: 4374.3 },
    { date: '2021-07-15', value: 4360.03 },
    { date: '2021-07-16', value: 4327.16 },
    { date: '2021-07-19', value: 4258.49 },
    { date: '2021-07-20', value: 4323.06 },
    { date: '2021-07-21', value: 4358.69 },
    { date: '2021-07-22', value: 4367.48 },
    { date: '2021-07-23', value: 4411.79 },
    { date: '2021-07-26', value: 4422.3 },
    { date: '2021-07-27', value: 4401.46 },
    { date: '2021-07-28', value: 4400.64 },
    { date: '2021-07-29', value: 4419.15 },
    { date: '2021-07-30', value: 4395.26 },
    { date: '2021-08-02', value: 4387.16 },
    { date: '2021-08-03', value: 4423.15 },
    { date: '2021-08-04', value: 4402.66 },
    { date: '2021-08-05', value: 4429.1 },
    { date: '2021-08-06', value: 4436.52 },
    { date: '2021-08-09', value: 4432.35 },
    { date: '2021-08-10', value: 4436.75 },
    { date: '2021-08-11', value: 4447.7 },
    { date: '2021-08-12', value: 4460.83 },
    { date: '2021-08-13', value: 4468.0 },
    { date: '2021-08-16', value: 4479.71 },
    { date: '2021-08-17', value: 4448.08 },
    { date: '2021-08-18', value: 4400.27 },
    { date: '2021-08-19', value: 4405.8 },
    { date: '2021-08-20', value: 4441.67 },
    { date: '2021-08-23', value: 4479.53 },
    { date: '2021-08-24', value: 4486.23 },
    { date: '2021-08-25', value: 4496.19 },
    { date: '2021-08-26', value: 4470.0 },
    { date: '2021-08-27', value: 4509.37 },
    { date: '2021-08-30', value: 4528.79 },
    { date: '2021-08-31', value: 4522.68 },
    { date: '2021-09-01', value: 4524.09 },
    { date: '2021-09-02', value: 4536.95 },
    { date: '2021-09-03', value: 4535.43 },
    { date: '2021-09-07', value: 4520.03 },
    { date: '2021-09-08', value: 4514.07 },
    { date: '2021-09-09', value: 4493.28 },
    { date: '2021-09-10', value: 4458.58 },
    { date: '2021-09-13', value: 4468.73 },
    { date: '2021-09-14', value: 4443.05 },
    { date: '2021-09-15', value: 4480.7 },
    { date: '2021-09-16', value: 4473.75 },
    { date: '2021-09-17', value: 4432.99 },
    { date: '2021-09-20', value: 4357.73 },
    { date: '2021-09-21', value: 4354.19 },
    { date: '2021-09-22', value: 4395.64 },
    { date: '2021-09-23', value: 4448.98 },
    { date: '2021-09-24', value: 4455.48 },
    { date: '2021-09-27', value: 4443.11 },
    { date: '2021-09-28', value: 4352.63 },
    { date: '2021-09-29', value: 4359.46 },
    { date: '2021-09-30', value: 4307.54 },
    { date: '2021-10-01', value: 4357.04 },
    { date: '2021-10-04', value: 4300.46 },
    { date: '2021-10-05', value: 4345.72 },
    { date: '2021-10-06', value: 4363.55 },
    { date: '2021-10-07', value: 4399.76 },
    { date: '2021-10-08', value: 4391.34 },
    { date: '2021-10-11', value: 4361.19 },
    { date: '2021-10-12', value: 4350.65 },
    { date: '2021-10-13', value: 4363.8 },
    { date: '2021-10-14', value: 4438.26 },
    { date: '2021-10-15', value: 4471.37 },
    { date: '2021-10-18', value: 4486.46 },
    { date: '2021-10-19', value: 4519.63 },
    { date: '2021-10-20', value: 4536.19 },
    { date: '2021-10-21', value: 4549.78 },
    { date: '2021-10-22', value: 4544.9 },
    { date: '2021-10-25', value: 4566.48 },
    { date: '2021-10-26', value: 4574.79 },
    { date: '2021-10-27', value: 4551.68 },
    { date: '2021-10-28', value: 4596.42 },
    { date: '2021-10-29', value: 4605.38 },
    { date: '2021-11-01', value: 4613.67 },
    { date: '2021-11-02', value: 4630.65 },
    { date: '2021-11-03', value: 4660.57 },
    { date: '2021-11-04', value: 4680.06 },
    { date: '2021-11-05', value: 4697.53 },
    { date: '2021-11-08', value: 4701.7 },
    { date: '2021-11-09', value: 4685.25 },
    { date: '2021-11-10', value: 4646.71 },
    { date: '2021-11-11', value: 4649.27 },
    { date: '2021-11-12', value: 4682.85 },
    { date: '2021-11-15', value: 4682.8 },
    { date: '2021-11-16', value: 4700.9 },
    { date: '2021-11-17', value: 4688.67 },
    { date: '2021-11-18', value: 4704.54 },
    { date: '2021-11-19', value: 4697.96 },
    { date: '2021-11-22', value: 4682.94 },
    { date: '2021-11-23', value: 4690.7 },
    { date: '2021-11-24', value: 4701.46 },
    { date: '2021-11-26', value: 4594.62 },
    { date: '2021-11-29', value: 4655.27 },
    { date: '2021-11-30', value: 4567.0 },
    { date: '2021-12-01', value: 4513.04 },
    { date: '2021-12-02', value: 4577.1 },
    { date: '2021-12-03', value: 4538.43 },
    { date: '2021-12-06', value: 4591.67 },
    { date: '2021-12-07', value: 4686.75 },
    { date: '2021-12-08', value: 4701.21 },
    { date: '2021-12-09', value: 4667.45 },
    { date: '2021-12-10', value: 4712.02 },
    { date: '2021-12-13', value: 4668.97 },
    { date: '2021-12-14', value: 4634.09 },
    { date: '2021-12-15', value: 4709.85 },
    { date: '2021-12-16', value: 4668.67 },
    { date: '2021-12-17', value: 4620.64 },
    { date: '2021-12-20', value: 4568.02 },
    { date: '2021-12-21', value: 4649.23 },
    { date: '2021-12-22', value: 4696.56 },
    { date: '2021-12-23', value: 4725.79 },
    { date: '2021-12-27', value: 4791.19 },
    { date: '2021-12-28', value: 4786.35 },
    { date: '2021-12-29', value: 4793.06 },
    { date: '2021-12-30', value: 4778.73 },
    { date: '2021-12-31', value: 4766.18 },
    { date: '2022-01-03', value: 4796.56 },
    { date: '2022-01-04', value: 4793.54 },
    { date: '2022-01-05', value: 4700.58 },
    { date: '2022-01-06', value: 4696.05 },
    { date: '2022-01-07', value: 4677.03 },
    { date: '2022-01-10', value: 4670.29 },
    { date: '2022-01-11', value: 4713.07 },
    { date: '2022-01-12', value: 4726.35 },
    { date: '2022-01-13', value: 4659.03 },
    { date: '2022-01-14', value: 4662.85 },
    { date: '2022-01-18', value: 4577.11 },
    { date: '2022-01-19', value: 4532.76 },
    { date: '2022-01-20', value: 4482.73 },
    { date: '2022-01-21', value: 4397.94 },
    { date: '2022-01-24', value: 4410.13 },
    { date: '2022-01-25', value: 4356.45 },
    { date: '2022-01-26', value: 4349.93 },
    { date: '2022-01-27', value: 4326.51 },
    { date: '2022-01-28', value: 4431.85 },
    { date: '2022-01-31', value: 4515.55 },
    { date: '2022-02-01', value: 4546.54 },
    { date: '2022-02-02', value: 4589.38 },
    { date: '2022-02-03', value: 4477.44 },
    { date: '2022-02-04', value: 4500.53 },
    { date: '2022-02-07', value: 4483.87 },
    { date: '2022-02-08', value: 4521.54 },
    { date: '2022-02-09', value: 4587.18 },
    { date: '2022-02-10', value: 4504.08 },
    { date: '2022-02-11', value: 4418.64 },
    { date: '2022-02-14', value: 4401.67 },
    { date: '2022-02-15', value: 4471.07 },
    { date: '2022-02-16', value: 4475.01 },
    { date: '2022-02-17', value: 4380.26 },
    { date: '2022-02-18', value: 4348.87 },
    { date: '2022-02-22', value: 4304.76 },
    { date: '2022-02-23', value: 4225.5 },
    { date: '2022-02-24', value: 4288.7 },
    { date: '2022-02-25', value: 4384.65 },
    { date: '2022-02-28', value: 4373.94 },
    { date: '2022-03-01', value: 4306.26 },
    { date: '2022-03-02', value: 4386.54 },
    { date: '2022-03-03', value: 4363.49 },
    { date: '2022-03-04', value: 4328.87 },
    { date: '2022-03-07', value: 4201.09 },
    { date: '2022-03-08', value: 4170.7 },
    { date: '2022-03-09', value: 4277.88 },
    { date: '2022-03-10', value: 4259.52 },
    { date: '2022-03-11', value: 4204.31 },
    { date: '2022-03-14', value: 4173.11 },
    { date: '2022-03-15', value: 4262.45 },
    { date: '2022-03-16', value: 4357.86 },
    { date: '2022-03-17', value: 4411.67 },
    { date: '2022-03-18', value: 4463.12 },
    { date: '2022-03-21', value: 4461.18 },
    { date: '2022-03-22', value: 4511.61 },
    { date: '2022-03-23', value: 4456.24 },
    { date: '2022-03-24', value: 4520.16 },
    { date: '2022-03-25', value: 4543.06 },
    { date: '2022-03-28', value: 4575.52 },
    { date: '2022-03-29', value: 4631.6 },
    { date: '2022-03-30', value: 4602.45 },
    { date: '2022-03-31', value: 4530.41 },
    { date: '2022-04-01', value: 4545.86 },
    { date: '2022-04-04', value: 4582.64 },
    { date: '2022-04-05', value: 4525.12 },
    { date: '2022-04-06', value: 4481.15 },
    { date: '2022-04-07', value: 4500.21 },
    { date: '2022-04-08', value: 4488.28 },
    { date: '2022-04-11', value: 4412.53 },
    { date: '2022-04-12', value: 4397.45 },
    { date: '2022-04-13', value: 4446.59 },
    { date: '2022-04-14', value: 4392.59 },
    { date: '2022-04-18', value: 4391.69 },
    { date: '2022-04-19', value: 4462.21 },
    { date: '2022-04-20', value: 4459.45 },
    { date: '2022-04-21', value: 4393.66 },
    { date: '2022-04-22', value: 4271.78 },
    { date: '2022-04-25', value: 4296.12 },
    { date: '2022-04-26', value: 4175.2 },
    { date: '2022-04-27', value: 4183.96 },
    { date: '2022-04-28', value: 4287.5 },
    { date: '2022-04-29', value: 4131.93 },
    { date: '2022-05-02', value: 4155.38 },
    { date: '2022-05-03', value: 4175.48 },
    { date: '2022-05-04', value: 4300.17 },
    { date: '2022-05-05', value: 4146.87 },
    { date: '2022-05-06', value: 4123.34 },
    { date: '2022-05-09', value: 3991.24 },
    { date: '2022-05-10', value: 4001.05 },
    { date: '2022-05-11', value: 3935.18 },
    { date: '2022-05-12', value: 3930.08 },
    { date: '2022-05-13', value: 4023.89 },
    { date: '2022-05-16', value: 4008.01 },
    { date: '2022-05-17', value: 4088.85 },
    { date: '2022-05-18', value: 3923.68 },
    { date: '2022-05-19', value: 3900.79 },
    { date: '2022-05-20', value: 3901.36 },
    { date: '2022-05-23', value: 3973.75 },
    { date: '2022-05-24', value: 3941.48 },
    { date: '2022-05-25', value: 3978.73 },
    { date: '2022-05-26', value: 4057.84 },
    { date: '2022-05-27', value: 4158.24 },
    { date: '2022-05-31', value: 4132.15 },
    { date: '2022-06-01', value: 4101.23 },
    { date: '2022-06-02', value: 4176.82 },
    { date: '2022-06-03', value: 4108.54 },
    { date: '2022-06-06', value: 4121.43 },
    { date: '2022-06-07', value: 4160.68 },
    { date: '2022-06-08', value: 4115.77 },
    { date: '2022-06-09', value: 4017.82 },
    { date: '2022-06-10', value: 3900.86 },
    { date: '2022-06-13', value: 3749.63 },
    { date: '2022-06-14', value: 3735.48 },
    { date: '2022-06-15', value: 3789.99 },
    { date: '2022-06-16', value: 3666.77 },
    { date: '2022-06-17', value: 3674.84 },
    { date: '2022-06-21', value: 3764.79 },
    { date: '2022-06-22', value: 3759.89 },
    { date: '2022-06-23', value: 3795.73 },
    { date: '2022-06-24', value: 3911.74 },
    { date: '2022-06-27', value: 3900.11 },
    { date: '2022-06-28', value: 3821.55 },
    { date: '2022-06-29', value: 3818.83 },
    { date: '2022-06-30', value: 3785.38 },
    { date: '2022-07-01', value: 3825.33 },
    { date: '2022-07-05', value: 3831.39 },
    { date: '2022-07-06', value: 3845.08 },
    { date: '2022-07-07', value: 3902.62 },
    { date: '2022-07-08', value: 3899.38 },
    { date: '2022-07-11', value: 3854.43 },
    { date: '2022-07-12', value: 3818.8 },
    { date: '2022-07-13', value: 3801.78 },
    { date: '2022-07-14', value: 3790.38 },
    { date: '2022-07-15', value: 3863.16 },
    { date: '2022-07-18', value: 3830.85 },
    { date: '2022-07-19', value: 3936.69 },
    { date: '2022-07-20', value: 3959.9 },
    { date: '2022-07-21', value: 3998.95 },
    { date: '2022-07-22', value: 3961.63 },
    { date: '2022-07-25', value: 3966.84 },
    { date: '2022-07-26', value: 3921.05 },
    { date: '2022-07-27', value: 4023.61 },
    { date: '2022-07-28', value: 4072.43 },
    { date: '2022-07-29', value: 4130.29 },
    { date: '2022-08-01', value: 4118.63 },
    { date: '2022-08-02', value: 4091.19 },
    { date: '2022-08-03', value: 4155.17 },
    { date: '2022-08-04', value: 4151.94 },
    { date: '2022-08-05', value: 4145.19 },
    { date: '2022-08-08', value: 4140.06 },
    { date: '2022-08-09', value: 4122.47 },
    { date: '2022-08-10', value: 4210.24 },
    { date: '2022-08-11', value: 4207.27 },
    { date: '2022-08-12', value: 4280.15 },
    { date: '2022-08-15', value: 4297.14 },
    { date: '2022-08-16', value: 4305.2 },
    { date: '2022-08-17', value: 4274.04 },
    { date: '2022-08-18', value: 4283.74 },
    { date: '2022-08-19', value: 4228.48 },
    { date: '2022-08-22', value: 4137.99 },
    { date: '2022-08-23', value: 4128.73 },
    { date: '2022-08-24', value: 4140.77 },
    { date: '2022-08-25', value: 4199.12 },
    { date: '2022-08-26', value: 4057.66 },
    { date: '2022-08-29', value: 4030.61 },
    { date: '2022-08-30', value: 3986.16 },
    { date: '2022-08-31', value: 3955.0 },
    { date: '2022-09-01', value: 3966.85 },
    { date: '2022-09-02', value: 3924.26 },
    { date: '2022-09-06', value: 3908.19 },
    { date: '2022-09-07', value: 3979.87 },
    { date: '2022-09-08', value: 4006.18 },
    { date: '2022-09-09', value: 4067.36 },
    { date: '2022-09-12', value: 4110.41 },
    { date: '2022-09-13', value: 3932.69 },
    { date: '2022-09-14', value: 3946.01 },
    { date: '2022-09-15', value: 3901.35 },
    { date: '2022-09-16', value: 3873.33 },
    { date: '2022-09-19', value: 3899.89 },
    { date: '2022-09-20', value: 3855.93 },
    { date: '2022-09-21', value: 3789.93 },
    { date: '2022-09-22', value: 3757.99 },
    { date: '2022-09-23', value: 3693.23 },
    { date: '2022-09-26', value: 3655.04 },
    { date: '2022-09-27', value: 3647.29 },
    { date: '2022-09-28', value: 3719.04 },
    { date: '2022-09-29', value: 3640.47 },
    { date: '2022-09-30', value: 3585.62 },
    { date: '2022-10-03', value: 3678.43 },
    { date: '2022-10-04', value: 3790.93 },
    { date: '2022-10-05', value: 3783.28 },
    { date: '2022-10-06', value: 3744.52 },
    { date: '2022-10-07', value: 3639.66 },
    { date: '2022-10-10', value: 3612.39 },
    { date: '2022-10-11', value: 3588.84 },
    { date: '2022-10-12', value: 3577.03 },
    { date: '2022-10-13', value: 3669.91 },
    { date: '2022-10-14', value: 3583.07 },
    { date: '2022-10-17', value: 3677.95 },
    { date: '2022-10-18', value: 3719.98 },
    { date: '2022-10-19', value: 3695.16 },
    { date: '2022-10-20', value: 3665.78 },
    { date: '2022-10-21', value: 3752.75 },
    { date: '2022-10-24', value: 3797.34 },
    { date: '2022-10-25', value: 3859.11 },
    { date: '2022-10-26', value: 3830.6 },
    { date: '2022-10-27', value: 3807.3 },
    { date: '2022-10-28', value: 3901.06 },
    { date: '2022-10-31', value: 3871.98 },
    { date: '2022-11-01', value: 3856.1 },
    { date: '2022-11-02', value: 3759.69 },
    { date: '2022-11-03', value: 3719.89 },
    { date: '2022-11-04', value: 3770.55 },
    { date: '2022-11-07', value: 3806.8 },
    { date: '2022-11-08', value: 3828.11 },
    { date: '2022-11-09', value: 3748.57 },
    { date: '2022-11-10', value: 3956.37 },
    { date: '2022-11-11', value: 3992.93 },
    { date: '2022-11-14', value: 3957.25 },
    { date: '2022-11-15', value: 3991.73 },
    { date: '2022-11-16', value: 3958.79 },
    { date: '2022-11-17', value: 3946.56 },
    { date: '2022-11-18', value: 3965.34 },
    { date: '2022-11-21', value: 3949.94 },
    { date: '2022-11-22', value: 4003.58 },
    { date: '2022-11-23', value: 4027.26 },
    { date: '2022-11-25', value: 4026.12 },
    { date: '2022-11-28', value: 3963.94 },
    { date: '2022-11-29', value: 3957.63 },
    { date: '2022-11-30', value: 4080.11 },
    { date: '2022-12-01', value: 4076.57 },
    { date: '2022-12-02', value: 4071.7 },
    { date: '2022-12-05', value: 3998.84 },
    { date: '2022-12-06', value: 3941.26 },
    { date: '2022-12-07', value: 3933.92 },
    { date: '2022-12-08', value: 3963.51 },
    { date: '2022-12-09', value: 3934.38 },
    { date: '2022-12-12', value: 3990.56 },
    { date: '2022-12-13', value: 4019.65 },
    { date: '2022-12-14', value: 3995.32 },
    { date: '2022-12-15', value: 3895.75 },
    { date: '2022-12-16', value: 3852.36 },
    { date: '2022-12-19', value: 3817.66 },
    { date: '2022-12-20', value: 3821.62 },
    { date: '2022-12-21', value: 3878.44 },
    { date: '2022-12-22', value: 3822.39 },
    { date: '2022-12-23', value: 3844.82 },
    { date: '2022-12-27', value: 3829.25 },
    { date: '2022-12-28', value: 3783.22 },
    { date: '2022-12-29', value: 3849.28 },
    { date: '2022-12-30', value: 3839.5 },
    { date: '2023-01-03', value: 3824.14 },
    { date: '2023-01-04', value: 3852.97 },
    { date: '2023-01-05', value: 3808.1 },
    { date: '2023-01-06', value: 3895.08 },
    { date: '2023-01-09', value: 3892.09 },
    { date: '2023-01-10', value: 3919.25 },
    { date: '2023-01-11', value: 3969.61 },
    { date: '2023-01-12', value: 3983.17 },
    { date: '2023-01-13', value: 3999.09 },
    { date: '2023-01-17', value: 3990.97 },
    { date: '2023-01-18', value: 3928.86 },
    { date: '2023-01-19', value: 3898.85 },
    { date: '2023-01-20', value: 3972.61 },
    { date: '2023-01-23', value: 4019.81 },
    { date: '2023-01-24', value: 4016.95 },
    { date: '2023-01-25', value: 4016.22 },
    { date: '2023-01-26', value: 4060.43 },
    { date: '2023-01-27', value: 4070.56 },
    { date: '2023-01-30', value: 4017.77 },
    { date: '2023-01-31', value: 4076.6 },
    { date: '2023-02-01', value: 4119.21 },
    { date: '2023-02-02', value: 4179.76 },
    { date: '2023-02-03', value: 4136.48 },
    { date: '2023-02-06', value: 4111.08 },
    { date: '2023-02-07', value: 4164.0 },
    { date: '2023-02-08', value: 4117.86 },
    { date: '2023-02-09', value: 4081.5 },
    { date: '2023-02-10', value: 4090.46 },
    { date: '2023-02-13', value: 4137.29 },
    { date: '2023-02-14', value: 4136.13 },
    { date: '2023-02-15', value: 4147.6 },
    { date: '2023-02-16', value: 4090.41 },
    { date: '2023-02-17', value: 4079.09 },
    { date: '2023-02-21', value: 3997.34 },
    { date: '2023-02-22', value: 3991.05 },
    { date: '2023-02-23', value: 4012.32 },
    { date: '2023-02-24', value: 3970.04 },
    { date: '2023-02-27', value: 3982.24 },
    { date: '2023-02-28', value: 3970.15 },
    { date: '2023-03-01', value: 3951.39 },
    { date: '2023-03-02', value: 3981.35 },
    { date: '2023-03-03', value: 4045.64 },
    { date: '2023-03-06', value: 4048.42 },
    { date: '2023-03-07', value: 3986.37 },
    { date: '2023-03-08', value: 3992.01 },
    { date: '2023-03-09', value: 3918.32 },
    { date: '2023-03-10', value: 3861.59 },
    { date: '2023-03-13', value: 3855.76 },
    { date: '2023-03-14', value: 3919.29 },
    { date: '2023-03-15', value: 3891.93 },
    { date: '2023-03-16', value: 3960.28 },
    { date: '2023-03-17', value: 3916.64 },
    { date: '2023-03-20', value: 3951.57 },
    { date: '2023-03-21', value: 4002.87 },
    { date: '2023-03-22', value: 3936.97 },
    { date: '2023-03-23', value: 3948.72 },
    { date: '2023-03-24', value: 3970.99 },
    { date: '2023-03-27', value: 3977.53 },
    { date: '2023-03-28', value: 3971.27 },
    { date: '2023-03-29', value: 4027.81 },
    { date: '2023-03-30', value: 4050.83 },
    { date: '2023-03-31', value: 4109.31 },
    { date: '2023-04-03', value: 4124.51 },
    { date: '2023-04-04', value: 4100.6 },
    { date: '2023-04-05', value: 4090.38 },
    { date: '2023-04-06', value: 4105.02 },
    { date: '2023-04-10', value: 4109.11 },
    { date: '2023-04-11', value: 4108.94 },
    { date: '2023-04-12', value: 4091.95 },
    { date: '2023-04-13', value: 4146.22 },
    { date: '2023-04-14', value: 4137.64 },
    { date: '2023-04-17', value: 4151.32 },
    { date: '2023-04-18', value: 4154.87 },
    { date: '2023-04-19', value: 4154.52 },
    { date: '2023-04-20', value: 4129.79 },
    { date: '2023-04-21', value: 4133.52 },
    { date: '2023-04-24', value: 4137.04 },
    { date: '2023-04-25', value: 4071.63 },
    { date: '2023-04-26', value: 4055.99 },
    { date: '2023-04-27', value: 4135.35 },
    { date: '2023-04-28', value: 4169.48 },
    { date: '2023-05-01', value: 4167.87 },
    { date: '2023-05-02', value: 4119.58 },
    { date: '2023-05-03', value: 4090.75 },
    { date: '2023-05-04', value: 4061.22 },
    { date: '2023-05-05', value: 4136.25 },
    { date: '2023-05-08', value: 4138.12 },
    { date: '2023-05-09', value: 4119.17 },
    { date: '2023-05-10', value: 4137.64 },
    { date: '2023-05-11', value: 4130.62 },
    { date: '2023-05-12', value: 4124.08 },
    { date: '2023-05-15', value: 4136.28 },
    { date: '2023-05-16', value: 4109.9 },
    { date: '2023-05-17', value: 4158.77 },
    { date: '2023-05-18', value: 4198.05 },
    { date: '2023-05-19', value: 4191.98 },
    { date: '2023-05-22', value: 4192.63 },
    { date: '2023-05-23', value: 4145.58 },
    { date: '2023-05-24', value: 4115.24 },
    { date: '2023-05-25', value: 4151.28 },
    { date: '2023-05-26', value: 4205.45 },
    { date: '2023-05-30', value: 4205.52 },
    { date: '2023-05-31', value: 4179.83 },
    { date: '2023-06-01', value: 4221.02 },
    { date: '2023-06-02', value: 4282.37 },
    { date: '2023-06-05', value: 4273.79 },
    { date: '2023-06-06', value: 4283.85 },
    { date: '2023-06-07', value: 4267.52 },
    { date: '2023-06-08', value: 4293.93 },
    { date: '2023-06-09', value: 4298.86 },
    { date: '2023-06-12', value: 4338.93 },
    { date: '2023-06-13', value: 4369.01 },
    { date: '2023-06-14', value: 4372.59 },
    { date: '2023-06-15', value: 4425.84 },
    { date: '2023-06-16', value: 4409.59 },
    { date: '2023-06-20', value: 4388.71 },
    { date: '2023-06-21', value: 4365.69 },
    { date: '2023-06-22', value: 4381.89 },
    { date: '2023-06-23', value: 4348.33 },
    { date: '2023-06-26', value: 4328.82 },
    { date: '2023-06-27', value: 4378.41 },
    { date: '2023-06-28', value: 4376.86 },
    { date: '2023-06-29', value: 4396.44 },
    { date: '2023-06-30', value: 4450.38 },
    { date: '2023-07-03', value: 4455.59 },
    { date: '2023-07-05', value: 4446.82 },
    { date: '2023-07-06', value: 4411.59 },
    { date: '2023-07-07', value: 4398.95 },
    { date: '2023-07-10', value: 4409.53 },
    { date: '2023-07-11', value: 4439.26 },
    { date: '2023-07-12', value: 4472.16 },
    { date: '2023-07-13', value: 4510.04 },
    { date: '2023-07-14', value: 4505.42 },
    { date: '2023-07-17', value: 4522.79 },
    { date: '2023-07-18', value: 4554.98 },
    { date: '2023-07-19', value: 4565.72 },
    { date: '2023-07-20', value: 4534.87 },
    { date: '2023-07-21', value: 4536.34 },
    { date: '2023-07-24', value: 4554.64 },
    { date: '2023-07-25', value: 4567.46 },
    { date: '2023-07-26', value: 4566.75 },
    { date: '2023-07-27', value: 4537.41 },
    { date: '2023-07-28', value: 4582.23 },
    { date: '2023-07-31', value: 4588.96 },
    { date: '2023-08-01', value: 4576.73 },
    { date: '2023-08-02', value: 4513.39 },
    { date: '2023-08-03', value: 4501.89 },
    { date: '2023-08-04', value: 4478.03 },
    { date: '2023-08-07', value: 4518.44 },
    { date: '2023-08-08', value: 4499.38 },
    { date: '2023-08-09', value: 4467.71 },
    { date: '2023-08-10', value: 4468.83 },
    { date: '2023-08-11', value: 4464.05 },
    { date: '2023-08-14', value: 4489.72 },
    { date: '2023-08-15', value: 4437.86 },
    { date: '2023-08-16', value: 4404.33 },
    { date: '2023-08-17', value: 4370.36 },
    { date: '2023-08-18', value: 4369.71 },
    { date: '2023-08-21', value: 4399.77 },
    { date: '2023-08-22', value: 4387.55 },
    { date: '2023-08-23', value: 4436.01 },
    { date: '2023-08-24', value: 4376.31 },
    { date: '2023-08-25', value: 4405.71 },
    { date: '2023-08-28', value: 4433.31 },
    { date: '2023-08-29', value: 4497.63 },
    { date: '2023-08-30', value: 4514.87 },
    { date: '2023-08-31', value: 4507.66 },
    { date: '2023-09-01', value: 4515.77 },
    { date: '2023-09-05', value: 4496.83 },
    { date: '2023-09-06', value: 4465.48 },
    { date: '2023-09-07', value: 4451.14 },
    { date: '2023-09-08', value: 4457.49 },
    { date: '2023-09-11', value: 4487.46 },
    { date: '2023-09-12', value: 4461.9 },
    { date: '2023-09-13', value: 4467.44 },
    { date: '2023-09-14', value: 4505.1 },
    { date: '2023-09-15', value: 4450.32 },
    { date: '2023-09-18', value: 4453.53 },
    { date: '2023-09-19', value: 4443.95 },
    { date: '2023-09-20', value: 4402.2 },
    { date: '2023-09-21', value: 4330.0 },
    { date: '2023-09-22', value: 4320.06 },
    { date: '2023-09-25', value: 4337.44 },
    { date: '2023-09-26', value: 4273.53 },
    { date: '2023-09-27', value: 4274.51 },
    { date: '2023-09-28', value: 4299.7 },
    { date: '2023-09-29', value: 4288.05 },
    { date: '2023-10-02', value: 4288.39 },
    { date: '2023-10-03', value: 4229.45 },
    { date: '2023-10-04', value: 4263.75 },
    { date: '2023-10-05', value: 4258.19 },
    { date: '2023-10-06', value: 4308.5 },
    { date: '2023-10-09', value: 4335.66 },
    { date: '2023-10-10', value: 4358.24 },
    { date: '2023-10-11', value: 4376.95 },
    { date: '2023-10-12', value: 4349.61 },
    { date: '2023-10-13', value: 4327.78 },
    { date: '2023-10-16', value: 4373.63 },
    { date: '2023-10-17', value: 4373.2 },
    { date: '2023-10-18', value: 4314.6 },
    { date: '2023-10-19', value: 4278.0 },
    { date: '2023-10-20', value: 4224.16 },
    { date: '2023-10-23', value: 4217.04 },
    { date: '2023-10-24', value: 4247.68 },
    { date: '2023-10-25', value: 4186.77 },
    { date: '2023-10-26', value: 4137.23 },
    { date: '2023-10-27', value: 4117.37 },
    { date: '2023-10-30', value: 4166.82 },
    { date: '2023-10-31', value: 4193.8 },
    { date: '2023-11-01', value: 4237.86 },
    { date: '2023-11-02', value: 4317.78 },
    { date: '2023-11-03', value: 4358.34 },
    { date: '2023-11-06', value: 4365.98 },
    { date: '2023-11-07', value: 4378.38 },
    { date: '2023-11-08', value: 4382.78 },
    { date: '2023-11-09', value: 4347.35 },
    { date: '2023-11-10', value: 4415.24 },
    { date: '2023-11-13', value: 4411.55 },
    { date: '2023-11-14', value: 4495.7 },
    { date: '2023-11-15', value: 4502.88 },
    { date: '2023-11-16', value: 4508.24 },
    { date: '2023-11-17', value: 4514.02 },
    { date: '2023-11-20', value: 4547.38 },
    { date: '2023-11-21', value: 4538.19 },
    { date: '2023-11-22', value: 4556.62 },
    { date: '2023-11-24', value: 4559.34 },
    { date: '2023-11-27', value: 4550.43 },
    { date: '2023-11-28', value: 4554.89 },
    { date: '2023-11-29', value: 4550.58 },
    { date: '2023-11-30', value: 4567.8 },
    { date: '2023-12-01', value: 4594.63 },
    { date: '2023-12-04', value: 4569.78 },
    { date: '2023-12-05', value: 4567.18 },
    { date: '2023-12-06', value: 4549.34 },
    { date: '2023-12-07', value: 4585.59 },
    { date: '2023-12-08', value: 4604.37 },
    { date: '2023-12-11', value: 4622.44 },
    { date: '2023-12-12', value: 4643.7 },
    { date: '2023-12-13', value: 4707.09 },
    { date: '2023-12-14', value: 4719.55 },
    { date: '2023-12-15', value: 4719.19 },
    { date: '2023-12-18', value: 4740.56 },
    { date: '2023-12-19', value: 4768.37 },
    { date: '2023-12-20', value: 4698.35 },
    { date: '2023-12-21', value: 4746.75 },
    { date: '2023-12-22', value: 4754.63 },
    { date: '2023-12-26', value: 4774.75 },
    { date: '2023-12-27', value: 4781.58 },
    { date: '2023-12-28', value: 4783.35 },
    { date: '2023-12-29', value: 4769.83 },
    { date: '2024-01-02', value: 4742.83 },
    { date: '2024-01-03', value: 4704.81 },
    { date: '2024-01-04', value: 4688.68 },
    { date: '2024-01-05', value: 4697.24 },
    { date: '2024-01-08', value: 4763.54 },
    { date: '2024-01-09', value: 4756.5 },
    { date: '2024-01-10', value: 4783.45 },
    { date: '2024-01-11', value: 4780.24 },
    { date: '2024-01-12', value: 4783.83 },
    { date: '2024-01-16', value: 4765.98 },
    { date: '2024-01-17', value: 4739.21 },
    { date: '2024-01-18', value: 4780.94 },
    { date: '2024-01-19', value: 4839.81 },
    { date: '2024-01-22', value: 4850.43 },
    { date: '2024-01-23', value: 4864.6 },
    { date: '2024-01-24', value: 4868.55 },
];
